import React, { useEffect, useState, useRef } from "react";
import { Modal, FormGroup, Tooltip, Checkbox } from "@mui/material";
import Styles from "../AddListing/AddListingModal.module.css";
import { Close } from "@mui/icons-material";
import { ReactComponent as Download } from "../../../../assets/images/downloadOrange.svg";
import { ReactComponent as DeleteIcon } from "../../../../assets/images/RemoveIcon.svg";
import { ReactComponent as Upload } from "../../../../assets/images/uploadIcon.svg";
import { ReactComponent as AddIcon } from "../../../../assets/images/AdditionIcon.svg";
import DateInput from "../../../../commons/Inputs/DateInput/DateInput";
import TimeInput from "../../../../commons/Inputs/TimeInput/TimeInput";
import TextInput from "../../../../commons/Inputs/TextInput/TextInput";
import { ReactComponent as ViewIcon } from "../../../../assets/images/view.svg";
import { ReactComponent as CrossIcon } from "../../../../assets/images/cross.svg";
import { ReactComponent as Info } from "../../../../assets/images/info.svg";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  createBankingList,
  uploadTC,
  placeBid,
} from "../../../../Services/ApiCalling/banking";
import {
  clearFieldError,
  formatDate,
  formatExpiryAt,
  parseDateTimeFlexible,
} from "../AddListing/helpers";
import {
  calculateTotalHours,
  calculateTotalHoursSafe,
} from "../../../../commons/FormatDate.js";
import BankingInjectFirst from "../../../../assets/docs/Listing Power Injection First DD-MM-YY.xlsx";
import BankingDrawFirst from "../../../../assets/docs/Listing Power Drawal First DD-MM-YY.xlsx";
import PreviewModal from "../../../../commons/PreviewModal/PreviewModal.jsx";
import ConfirmationModal from "../../../../commons/ConfirmationModal/ConfirmationModal.jsx";
import { fetchDocumentUrlByLedgerId } from "../../../../Redux/Slices/bankingSlice.js";
import { usePdfPreview } from "../../../../hooks/usePdfPreview.js";

const transformTimeForDisplay = (timeStr) => {
  if (timeStr === "23:59") {
    return "24:00";
  }
  return timeStr;
};

const transformTimeForBackend = (timeStr) => {
  if (!timeStr) return "";
  if (timeStr === "24:00") {
    return "23:59";
  }
  return timeStr;
};

const ConnectListingModal = ({
  open,
  handleClose,
  prefilledData = null,
  onSubmitSuccess = null,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const today = new Date();
  const editedQuantitiesRef = useRef(new Set());

  const defaultRow = {
    startTime: "",
    endTime: "",
    startDate: "",
    endDate: "",
    quantity: "",
    rtcChecked: false,
  };

  const [injectionModals, setInjectionModals] = useState([[{ ...defaultRow }]]);
  const [drawalModals, setDrawalModals] = useState([[{ ...defaultRow }]]);
  const [isInjectionOnTop, setIsInjectionOnTop] = useState(true);
  const [confirmToggleOpen, setConfirmToggleOpen] = useState(false);
  const [nextIsInjectionOnTop, setNextIsInjectionOnTop] =
    useState(isInjectionOnTop);
  const [activeType, setActiveType] = useState("GNA");
  const [settlementRate, setSettlementRate] = useState("DAM+");
  const [bankingFactor, setBankingFactor] = useState("");
  const [expiryDate, setExpiryDate] = useState("");
  const [expiryTime, setExpiryTime] = useState("");
  const [termsExpiryDate, setTermsExpiryDate] = useState("");
  const [termsExpiryTime, setTermsExpiryTime] = useState("");
  const [comments, setComments] = useState("");
  const [fileValue, setFileValue] = useState(null);
  const [docId, setDocId] = useState(null);
  const [tcFileData, setTcFileData] = useState(null);
  const [tcFileName, setTcFileName] = useState("");
  const [excelFileName, setExcelFileName] = useState("");
  const [excelFileData, setExcelFileData] = useState(null);
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [previewModal, setPreviewModal] = useState(false);
  const [previewFileUrl, setPreviewFileUrl] = useState(null);
  const [expiryAuto, setExpiryAuto] = useState(true);
  const [acceptSystemTerms, setAcceptSystemTerms] = useState(false);
  const [termsError, setTermsError] = useState(null);
  const [previewFileName, setPreviewFileName] = useState(null);
  const [hasUserModifiedTcApproval, setHasUserModifiedTcApproval] =
    useState(false);
  const hasUserModifiedTcApprovalRef = useRef(false);
  const [isTermsByPass, setIsTermsByPass] = useState(true);
  const [checked, setChecked] = useState(true);
  const { handlePreviewGeneralTerms, PdfPreviewModal } = usePdfPreview();

  const [submitConfirmModalOpen, setSubmitConfirmModalOpen] = useState(false);

  const finalTermsExpiryDate = termsExpiryDate;
  const finalTermsExpiryTime = termsExpiryTime;

  const handleClick = (type) => {
    const normalizedType = type === "T-GNA" ? "TGNA" : type;
    setActiveType(normalizedType);
  };

  const handleViewFile = async (ledgerDocumentId) => {
    if (!ledgerDocumentId) {
      toast.error("Please select a document to preview.");
      return;
    }
    try {
      const resultAction = await dispatch(
        fetchDocumentUrlByLedgerId(ledgerDocumentId),
      );
      if (fetchDocumentUrlByLedgerId.fulfilled.match(resultAction)) {
        const url = resultAction.payload?.url || resultAction.payload;
        const fileName =
          resultAction.payload?.filename ||
          fileValue?.fileName ||
          `terms_and_conditions_${ledgerDocumentId}.pdf`;

        if (url) {
          setPreviewFileUrl(url);
          setPreviewFileName(fileName);
          setPreviewModal(true);
        } else {
          console.error("Document URL not found");
          toast.error("Document URL not found");
        }
      } else {
        console.error("Error fetching document URL");
        toast.error("Could not fetch document URL.");
      }
    } catch (err) {
      console.error("Failed to fetch document URL", err);
      toast.error("Could not fetch document URL.");
    }
  };

  const handleClosePreview = () => {
    setPreviewModal(false);
    if (previewFileUrl) {
      URL.revokeObjectURL(previewFileUrl);
      setPreviewFileUrl(null);
    }
    setPreviewFileName(null);
  };

  const getMaxInjectionQuantity = () => {
    let maxQty = 0;
    injectionModals.forEach((modal) => {
      modal.forEach((slot) => {
        const qty = Number(slot.quantity) || 0;
        if (qty > maxQty) maxQty = qty;
      });
    });
    return maxQty;
  };

  const minTimeForStartTime = (row) => {
    const startDateObj = new Date(row.startDate);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    startDateObj.setHours(0, 0, 0, 0);
    if (startDateObj.getTime() === today.getTime()) {
      const threeHoursLater = new Date(
        new Date().getTime() + 3 * 60 * 60 * 1000,
      );
      const hours = String(threeHoursLater.getHours()).padStart(2, "0");
      const minutes = String(threeHoursLater.getMinutes()).padStart(2, "0");
      return `${hours}:${minutes}`;
    }
    return "00:00";
  };

  const isValidTimeInput = (time) => {
    const [h, m] = time.split(":").map(Number);
    return h >= 0 && h <= 23 && [0, 15, 30, 45].includes(m);
  };

  const isValidEndTime = (time) => {
    if (time === "24:00" || time === "23:59") return true;
    const [h, m] = time.split(":").map(Number);
    return h >= 0 && h <= 23 && [0, 15, 30, 45].includes(m);
  };

  const isTimeValid = (start, end) => {
    if (!start || !end) return false;
    const [sh, sm] = start.split(":").map(Number);
    let eh, em;
    if (end === "24:00") {
      eh = 24;
      em = 0;
    } else {
      [eh, em] = end.split(":").map(Number);
    }
    if (isNaN(sh) || isNaN(sm) || isNaN(eh) || isNaN(em)) return false;
    const startMinutes = sh * 60 + sm;
    const endMinutes = eh * 60 + em;
    return endMinutes > startMinutes;
  };

  const validateModalRows = (modals) => {
    const now = new Date();
    const isToday = (someDate) => {
      const today = new Date();
      return (
        someDate.getDate() === today.getDate() &&
        someDate.getMonth() === today.getMonth() &&
        someDate.getFullYear() === today.getFullYear()
      );
    };

    const newErrors = modals.map((modalRows) =>
      modalRows.map((row) => {
        const rowErrors = {};
        let startDT = null;
        let endDT = null;

        // Required field validation
        if (!row.startDate) rowErrors.startDate = "Start date required";
        if (!row.endDate) rowErrors.endDate = "End date required";
        if (!row.startTime) rowErrors.startTime = "Start time required";
        if (!row.endTime) rowErrors.endTime = "End time required";
        if (!row.quantity || Number(row.quantity) <= 0)
          rowErrors.quantity = "Quantity required";

        // Time format validation
        if (row.startTime && !isValidTimeInput(row.startTime)) {
          rowErrors.startTime = "Must be in 15 min steps, max 23:45";
        }

        if (row.endTime && !isValidEndTime(row.endTime)) {
          rowErrors.endTime = "Invalid time";
        }

        // Time logic validation - only when format is valid
        if (row.startTime && row.endTime && !rowErrors.endTime) {
          if (!isTimeValid(row.startTime, row.endTime)) {
            rowErrors.endTime = "End time must be later";
          }
        }

        // Date validation - only when both dates exist
        if (row.startDate && row.endDate) {
          const startDateOnly = new Date(row.startDate);
          const endDateOnly = new Date(row.endDate);
          startDateOnly.setHours(0, 0, 0, 0);
          endDateOnly.setHours(0, 0, 0, 0);

          if (startDateOnly > endDateOnly) {
            rowErrors.startDate = "Start date must be on or before end date";
            rowErrors.endDate = "End date must be on or after start date";
          }
        }

        // Date-time combination validation
        if (row.startDate && row.startTime) {
          startDT = parseDateTimeFlexible(row.startDate, row.startTime);
          if (startDT && isToday(new Date(row.startDate))) {
            const threeHoursLater = new Date(
              now.getTime() + 3 * 60 * 60 * 1000,
            );
            if (startDT < threeHoursLater) {
              rowErrors.startTime =
                "Start time should be at least 3 hours from current time";
            }
          }
        }

        if (row.endDate && row.endTime) {
          endDT = parseDateTimeFlexible(row.endDate, row.endTime);
        }

        if (startDT && endDT && endDT <= startDT) {
          rowErrors.endTime = "End time must be later";
        }

        return rowErrors;
      }),
    );
    return newErrors;
  };

  const getDateRangeArray = (start, end) => {
    if (!start || !end) return [];
    const dates = [];
    const s = new Date(start);
    const e = new Date(end);
    while (s <= e) {
      dates.push(s.toISOString().split("T")[0]);
      s.setDate(s.getDate() + 1);
    }
    return dates;
  };

  const timeToMinutes = (time) => {
    if (!time) return 0;
    const [h, m] = time.split(":").map(Number);
    return h * 60 + m;
  };

  const validateDateOverlaps = () => {
    const overlaps = [];
    injectionModals.forEach((injModal, injModalIdx) => {
      injModal.forEach((injSlot, injSlotIdx) => {
        drawalModals.forEach((drawModal, drawModalIdx) => {
          drawModal.forEach((drawSlot, drawSlotIdx) => {
            const injDates = getDateRangeArray(
              injSlot.startDate,
              injSlot.endDate,
            );
            const drawDates = getDateRangeArray(
              drawSlot.startDate,
              drawSlot.endDate,
            );
            const shared = injDates.filter((d) => drawDates.includes(d));
            if (shared.length > 0) {
              overlaps.push({
                injection: { modalIndex: injModalIdx, slotIndex: injSlotIdx },
                drawal: { modalIndex: drawModalIdx, slotIndex: drawSlotIdx },
              });
            }
          });
        });
      });
    });
    return overlaps;
  };

  const validateInjectionDrawalSlotTimeOverlaps = (
    injectionModals,
    drawalModals,
  ) => {
    const overlaps = [];
    injectionModals.forEach((injModal, injModalIdx) => {
      injModal.forEach((injSlot, injSlotIdx) => {
        drawalModals.forEach((drawModal, drawModalIdx) => {
          drawModal.forEach((drawSlot, drawSlotIdx) => {
            const injDates = getDateRangeArray(
              injSlot.startDate,
              injSlot.endDate,
            );
            const drawDates = getDateRangeArray(
              drawSlot.startDate,
              drawSlot.endDate,
            );
            const shared = injDates.filter((d) => drawDates.includes(d));
            if (shared.length > 0) {
              const injStart = timeToMinutes(injSlot.startTime);
              const injEnd = timeToMinutes(
                transformTimeForBackend(injSlot.endTime),
              );
              const drawStart = timeToMinutes(drawSlot.startTime);
              const drawEnd = timeToMinutes(
                transformTimeForBackend(drawSlot.endTime),
              );
              if (injStart < drawEnd && drawStart < injEnd) {
                overlaps.push({
                  injectModalIndex: injModalIdx,
                  injectSlotIndex: injSlotIdx,
                  drawalModalIndex: drawModalIdx,
                  drawalSlotIndex: drawSlotIdx,
                });
              }
            }
          });
        });
      });
    });
    return overlaps;
  };

  const transformSlots = (slots) => {
    // Filter out empty or invalid slots
    return slots
      .filter(
        (row) =>
          row &&
          typeof row === "object" &&
          row.startDate &&
          row.endDate &&
          row.startTime &&
          row.endTime &&
          row.quantity &&
          String(row.quantity).trim() !== "",
      )
      .map((row) => ({
        dateStartAt: formatDate(row.startDate),
        dateEndAt: formatDate(row.endDate),
        slotStartAt: transformTimeForBackend(row.startTime),
        slotEndAt: transformTimeForBackend(row.endTime),
        requiredQty: Number(row.quantity),
        minimumQty: 0,
      }));
  };

  const validateForm = () => {
    const newErrors = {
      injectionModals: [],
      drawalModals: [],
      bankingFactor: "",
      settlementRate: "",
      expiryDate: "",
      expiryTime: "",
      termsExpiryDate: "",
      termsExpiryTime: "",
      dateOverlap: "",
    };

    newErrors.injectionModals = validateModalRows(injectionModals);
    newErrors.drawalModals = validateModalRows(drawalModals);

    if (!bankingFactor || Number(bankingFactor) < 100) {
      newErrors.bankingFactor = "Banking factor must be ≥100";
    }
    if (!settlementRate || !/^DAM[+-]\d+(\.\d{1,3})?$/.test(settlementRate)) {
      newErrors.settlementRate = "Settlement Rate required (e.g., DAM+1.234)";
    } else {
      const damMatch = settlementRate.match(/^DAM([+-])(\d+(?:\.\d{1,3})?)$/);
      if (damMatch) {
        const sign = damMatch[1];
        const value = parseFloat(damMatch[2]);
        const actualValue = sign === "+" ? value : -value;

        if (actualValue < -9 || actualValue > 9) {
          newErrors.settlementRate = "DAM value must be b/w DAM-9 & DAM+9";
        }
      }
    }

    const allStartTimes = [];
    [...injectionModals.flat(), ...drawalModals.flat()].forEach((slot) => {
      if (slot.startDate && slot.startTime) {
        const dt = parseDateTimeFlexible(slot.startDate, slot.startTime);
        if (dt) allStartTimes.push(dt);
      }
    });

    const now = new Date();
    if (expiryDate && expiryTime) {
      const listingExpiryDT = parseDateTimeFlexible(expiryDate, expiryTime);
      if (listingExpiryDT && listingExpiryDT <= now) {
        newErrors.expiryDate = "Expiry date and time must be in future";
        newErrors.expiryTime = "Expiry date and time must be in future";
      }
    }

    if (finalTermsExpiryDate && finalTermsExpiryTime) {
      const termsExpiryDT = parseDateTimeFlexible(
        finalTermsExpiryDate,
        finalTermsExpiryTime,
      );
      if (termsExpiryDT && termsExpiryDT <= now) {
        newErrors.termsExpiryDate = "Expiry date and time must be in future";
        newErrors.termsExpiryTime = "Expiry date and time must be in future";
      }
    }

    if (expiryDate && expiryTime && allStartTimes.length > 0) {
      const listingExpiryDT = parseDateTimeFlexible(expiryDate, expiryTime);

      if (!isValidTimeInput(expiryTime)) {
        newErrors.expiryTime = "Must be in 15 min steps";
      }

      if (!listingExpiryDT) {
        newErrors.expiryDate = "Invalid date format";
        newErrors.expiryTime = "Invalid time format";
      } else {
        const earliestStart = new Date(
          Math.min(...allStartTimes.map((d) => d.getTime())),
        );

        if (listingExpiryDT >= earliestStart) {
          newErrors.expiryDate = "Must be before slot start";
          newErrors.expiryTime = "Must be before slot start";
        } else if (
          listingExpiryDT >
          new Date(earliestStart.getTime() - 3 * 60 * 60 * 1000)
        ) {
          newErrors.expiryDate = "Must be 3+ hours before slot";
          newErrors.expiryTime = "Must be 3+ hours before slot";
        }
      }
    }

    if (finalTermsExpiryDate && finalTermsExpiryTime) {
      const termsExpiryDT = parseDateTimeFlexible(
        finalTermsExpiryDate,
        finalTermsExpiryTime,
      );
      const listingExpiryDT = parseDateTimeFlexible(expiryDate, expiryTime);

      // if (!isValidTimeInput(finalTermsExpiryTime)) {
      //   newErrors.termsExpiryTime = "Must be in 15 min steps";
      // }

      if (!termsExpiryDT) {
        // newErrors.termsExpiryDate = "Invalid date format";
        // newErrors.termsExpiryTime = "Invalid time format";
      } else {
        if (listingExpiryDT && termsExpiryDT < listingExpiryDT) {
          // newErrors.termsExpiryDate = "Must be on or after Listing Expiry";
          // newErrors.termsExpiryTime = "Must be on or after Listing Expiry";
        }

        if (allStartTimes.length > 0) {
          const earliestStartDateTime = new Date(
            Math.min(...allStartTimes.map((d) => d.getTime())),
          );

          if (termsExpiryDT >= earliestStartDateTime) {
            // newErrors.termsExpiryDate = "Must be before slot start";
            // newErrors.termsExpiryTime = "Must be before slot start";
          } else if (
            termsExpiryDT >=
            new Date(earliestStartDateTime.getTime() - 2 * 60 * 60 * 1000)
          ) {
            // newErrors.termsExpiryDate = "Must be 3+ hours before slot";
            // newErrors.termsExpiryTime = "Must be 3+ hours before slot";
          }
        }
      }
    }

    const timeSlotOverlaps = validateInjectionDrawalSlotTimeOverlaps(
      injectionModals,
      drawalModals,
    );

    if (timeSlotOverlaps.length > 0) {
      newErrors.dateOverlap =
        "Injection and Drawal slots cannot overlap in time on the same date";

      timeSlotOverlaps.forEach((ov) => {
        if (!newErrors.injectionModals[ov.injectModalIndex]) {
          newErrors.injectionModals[ov.injectModalIndex] = [];
        }
        if (
          !newErrors.injectionModals[ov.injectModalIndex][ov.injectSlotIndex]
        ) {
          newErrors.injectionModals[ov.injectModalIndex][ov.injectSlotIndex] =
            {};
        }
        newErrors.injectionModals[ov.injectModalIndex][
          ov.injectSlotIndex
        ].startTime = `Overlaps with Drawal slot `;
        newErrors.injectionModals[ov.injectModalIndex][
          ov.injectSlotIndex
        ].endTime = `Overlaps with Drawal slot`;

        if (!newErrors.drawalModals[ov.drawalModalIndex]) {
          newErrors.drawalModals[ov.drawalModalIndex] = [];
        }
        if (!newErrors.drawalModals[ov.drawalModalIndex][ov.drawalSlotIndex]) {
          newErrors.drawalModals[ov.drawalModalIndex][ov.drawalSlotIndex] = {};
        }
        newErrors.drawalModals[ov.drawalModalIndex][
          ov.drawalSlotIndex
        ].startTime = `Overlaps with Injection slot `;
        newErrors.drawalModals[ov.drawalModalIndex][
          ov.drawalSlotIndex
        ].endTime = `Overlaps with Injection slot`;
      });
    } else {
      const dateOverlaps = validateDateOverlaps();
      if (dateOverlaps.length > 0) {
        let hasActualTimeConflict = false;

        dateOverlaps.forEach((overlap) => {
          const { injection, drawal } = overlap;

          const injectionSlot =
            injectionModals[injection.modalIndex][injection.slotIndex];
          const drawalSlot = drawalModals[drawal.modalIndex][drawal.slotIndex];

          const injectionDates = getDateRangeArray(
            injectionSlot.startDate,
            injectionSlot.endDate,
          );
          const drawalDates = getDateRangeArray(
            drawalSlot.startDate,
            drawalSlot.endDate,
          );
          const sharedDates = injectionDates.filter((date) =>
            drawalDates.includes(date),
          );

          if (sharedDates.length > 0) {
            const injStartTime = timeToMinutes(injectionSlot.startTime);
            const injEndTime = timeToMinutes(
              transformTimeForBackend(injectionSlot.endTime),
            );
            const drawStartTime = timeToMinutes(drawalSlot.startTime);
            const drawEndTime = timeToMinutes(
              transformTimeForBackend(drawalSlot.endTime),
            );

            if (injStartTime <= drawEndTime && drawStartTime <= injEndTime) {
              hasActualTimeConflict = true;
            }
          }
        });

        if (hasActualTimeConflict) {
          newErrors.dateOverlap =
            "Injection and drawal date ranges cannot overlap with conflicting times";

          dateOverlaps.forEach((overlap) => {
            const { injection, drawal } = overlap;

            if (!newErrors.injectionModals[injection.modalIndex]) {
              newErrors.injectionModals[injection.modalIndex] = [];
            }
            if (
              !newErrors.injectionModals[injection.modalIndex][
                injection.slotIndex
              ]
            ) {
              newErrors.injectionModals[injection.modalIndex][
                injection.slotIndex
              ] = {};
            }
            newErrors.injectionModals[injection.modalIndex][
              injection.slotIndex
            ].startDate = "Overlaps with drawal slot";
            newErrors.injectionModals[injection.modalIndex][
              injection.slotIndex
            ].endDate = "Overlaps with drawal slot";

            if (!newErrors.drawalModals[drawal.modalIndex]) {
              newErrors.drawalModals[drawal.modalIndex] = [];
            }
            if (!newErrors.drawalModals[drawal.modalIndex][drawal.slotIndex]) {
              newErrors.drawalModals[drawal.modalIndex][drawal.slotIndex] = {};
            }
            newErrors.drawalModals[drawal.modalIndex][
              drawal.slotIndex
            ].startDate = "Overlaps with injection slot";
            newErrors.drawalModals[drawal.modalIndex][
              drawal.slotIndex
            ].endDate = "Overlaps with injection slot";
          });
        }
      }
    }

    return newErrors;
  };

  const handleInjectionChange = (modalIndex, rowIndex, field, value) => {
    if (field === "quantity") {
      try {
        editedQuantitiesRef.current.add(`inj-${modalIndex}-${rowIndex}`);
      } catch (e) {}
      const numericValue = Number(value);
      if (numericValue < 0 || numericValue > 10000) {
        setErrors((prevErrors) => {
          const newErrors = { ...prevErrors };
          if (!newErrors.injectionModals) newErrors.injectionModals = [];
          if (!newErrors.injectionModals[modalIndex])
            newErrors.injectionModals[modalIndex] = [];
          if (!newErrors.injectionModals[modalIndex][rowIndex])
            newErrors.injectionModals[modalIndex][rowIndex] = {};
          newErrors.injectionModals[modalIndex][rowIndex][field] =
            "Quantity must be below 10,000";
          return newErrors;
        });
        return;
      } else if (numericValue > 0 && numericValue <= 10000) {
        setErrors((prevErrors) => {
          const newErrors = { ...prevErrors };
          if (newErrors.injectionModals?.[modalIndex]?.[rowIndex]) {
            delete newErrors.injectionModals[modalIndex][rowIndex][field];
            if (
              Object.keys(newErrors.injectionModals[modalIndex][rowIndex])
                .length === 0
            ) {
              newErrors.injectionModals[modalIndex].splice(rowIndex, 1);
            }
            if (newErrors.injectionModals[modalIndex].length === 0) {
              newErrors.injectionModals.splice(modalIndex, 1);
            }
          }
          return newErrors;
        });
      }
    }

    setInjectionModals((prev) => {
      const currentRow = prev[modalIndex][rowIndex];
      let updatedRow = { ...currentRow, [field]: value };

      // Auto-select RTC button if user inputs 00:00 to 24:00 (or 23:59 from backend)
      if (field === "endTime" && (value === "24:00" || value === "23:59")) {
        if (
          currentRow.startTime === "00:00" ||
          updatedRow.startTime === "00:00"
        ) {
          updatedRow = { ...updatedRow, rtcChecked: true };
        }
      } else if (field === "startTime" && value === "00:00") {
        if (
          currentRow.endTime === "24:00" ||
          currentRow.endTime === "23:59" ||
          updatedRow.endTime === "24:00" ||
          updatedRow.endTime === "23:59"
        ) {
          updatedRow = { ...updatedRow, rtcChecked: true };
        }
      }

      // Also ensure rtcChecked is set when both conditions are met in the updated row
      if (
        updatedRow.startTime === "00:00" &&
        (updatedRow.endTime === "24:00" || updatedRow.endTime === "23:59") &&
        !updatedRow.rtcChecked
      ) {
        updatedRow = { ...updatedRow, rtcChecked: true };
      }

      return prev.map((modalRows, idx) =>
        idx === modalIndex
          ? modalRows.map((r, rIdx) => (rIdx === rowIndex ? updatedRow : r))
          : modalRows,
      );
    });

    setErrors((prev) => {
      const newErrors = { ...prev };
      if (!Array.isArray(newErrors.injectionModals))
        newErrors.injectionModals = [];
      newErrors.injectionModals = [...newErrors.injectionModals];
      if (!Array.isArray(newErrors.injectionModals[modalIndex]))
        newErrors.injectionModals[modalIndex] = [];
      newErrors.injectionModals[modalIndex] = [
        ...newErrors.injectionModals[modalIndex],
      ];
      if (!newErrors.injectionModals[modalIndex][rowIndex])
        newErrors.injectionModals[modalIndex][rowIndex] = {};
      newErrors.injectionModals[modalIndex][rowIndex] = {
        ...newErrors.injectionModals[modalIndex][rowIndex],
      };
      const rowErrors = newErrors.injectionModals[modalIndex][rowIndex];

      if (field === "endTime") {
        if (!value) {
          delete rowErrors.endTime;
        } else if (!isValidEndTime(value)) {
          rowErrors.endTime = "Invalid time";
        } else {
          const startTime = injectionModals[modalIndex][rowIndex].startTime;
          if (startTime && !isTimeValid(startTime, value)) {
            rowErrors.endTime = "End time must be later";
          } else {
            delete rowErrors.endTime;
          }
        }
        newErrors.dateOverlap = "";
      } else if (field === "startTime") {
        if (value) delete rowErrors.startTime;
        const endTime = injectionModals[modalIndex][rowIndex].endTime;
        if (endTime && isValidEndTime(endTime)) {
          if (value && !isTimeValid(value, endTime)) {
            rowErrors.endTime = "End time must be later";
          } else {
            delete rowErrors.endTime;
          }
        }
        newErrors.dateOverlap = "";
      } else if (field === "startDate" || field === "endDate") {
        if (value) {
          delete rowErrors[field];
          const currentRow = injectionModals[modalIndex][rowIndex];
          const startDate =
            field === "startDate" ? value : currentRow.startDate;
          const endDate = field === "endDate" ? value : currentRow.endDate;
          if (startDate && endDate) {
            const start = new Date(startDate);
            const end = new Date(endDate);
            start.setHours(0, 0, 0, 0);
            end.setHours(0, 0, 0, 0);
            if (start <= end) {
              delete rowErrors.startDate;
              delete rowErrors.endDate;
            }
          }
          newErrors.dateOverlap = "";
        }
      } else if (value && field !== "quantity") {
        delete rowErrors[field];
        newErrors.dateOverlap = "";
        newErrors.termsExpiryDate = "";
        newErrors.termsExpiryTime = "";
        newErrors.expiryDate = "";
        newErrors.expiryTime = "";
      }

      return newErrors;
    });
  };
  const handleDrawalChange = (modalIndex, rowIndex, field, value) => {
    if (field === "quantity") {
      try {
        editedQuantitiesRef.current.add(`dra-${modalIndex}-${rowIndex}`);
      } catch (e) {}
      const numericValue = Number(value);
      if (numericValue < 0 || numericValue > 10000) {
        setErrors((prevErrors) => {
          const newErrors = { ...prevErrors };
          if (!newErrors.drawalModals) newErrors.drawalModals = [];
          if (!newErrors.drawalModals[modalIndex])
            newErrors.drawalModals[modalIndex] = [];
          if (!newErrors.drawalModals[modalIndex][rowIndex])
            newErrors.drawalModals[modalIndex][rowIndex] = {};
          newErrors.drawalModals[modalIndex][rowIndex][field] =
            "Quantity must be below 10,000";
          return newErrors;
        });
        return;
      } else if (numericValue > 0 && numericValue <= 10000) {
        setErrors((prevErrors) => {
          const newErrors = { ...prevErrors };
          if (newErrors.drawalModals?.[modalIndex]?.[rowIndex]) {
            delete newErrors.drawalModals[modalIndex][rowIndex][field];
            if (
              Object.keys(newErrors.drawalModals[modalIndex][rowIndex])
                .length === 0
            ) {
              newErrors.drawalModals[modalIndex].splice(rowIndex, 1);
            }
            if (newErrors.drawalModals[modalIndex].length === 0) {
              newErrors.drawalModals.splice(modalIndex, 1);
            }
          }
          return newErrors;
        });
      }
    }

    setDrawalModals((prev) => {
      const currentRow = prev[modalIndex][rowIndex];
      let updatedRow = { ...currentRow, [field]: value };

      // Auto-select RTC button if user inputs 00:00 to 24:00 (or 23:59 from backend)
      if (field === "endTime" && (value === "24:00" || value === "23:59")) {
        if (
          currentRow.startTime === "00:00" ||
          updatedRow.startTime === "00:00"
        ) {
          updatedRow = { ...updatedRow, rtcChecked: true };
        }
      } else if (field === "startTime" && value === "00:00") {
        if (
          currentRow.endTime === "24:00" ||
          currentRow.endTime === "23:59" ||
          updatedRow.endTime === "24:00" ||
          updatedRow.endTime === "23:59"
        ) {
          updatedRow = { ...updatedRow, rtcChecked: true };
        }
      }

      // Also ensure rtcChecked is set when both conditions are met in the updated row
      if (
        updatedRow.startTime === "00:00" &&
        (updatedRow.endTime === "24:00" || updatedRow.endTime === "23:59") &&
        !updatedRow.rtcChecked
      ) {
        updatedRow = { ...updatedRow, rtcChecked: true };
      }

      return prev.map((modalRows, idx) =>
        idx === modalIndex
          ? modalRows.map((r, rIdx) => (rIdx === rowIndex ? updatedRow : r))
          : modalRows,
      );
    });

    setErrors((prev) => {
      const newErrors = { ...prev };
      if (!Array.isArray(newErrors.drawalModals)) newErrors.drawalModals = [];
      newErrors.drawalModals = [...newErrors.drawalModals];
      if (!Array.isArray(newErrors.drawalModals[modalIndex]))
        newErrors.drawalModals[modalIndex] = [];
      newErrors.drawalModals[modalIndex] = [
        ...newErrors.drawalModals[modalIndex],
      ];
      if (!newErrors.drawalModals[modalIndex][rowIndex])
        newErrors.drawalModals[modalIndex][rowIndex] = {};
      newErrors.drawalModals[modalIndex][rowIndex] = {
        ...newErrors.drawalModals[modalIndex][rowIndex],
      };
      const rowErrors = newErrors.drawalModals[modalIndex][rowIndex];

      if (field === "endTime") {
        if (!value) {
          delete rowErrors.endTime;
        } else if (!isValidEndTime(value)) {
          rowErrors.endTime = "Invalid time";
        } else {
          const startTime = drawalModals[modalIndex][rowIndex].startTime;
          if (startTime && !isTimeValid(startTime, value)) {
            rowErrors.endTime = "End time must be later";
          } else {
            delete rowErrors.endTime;
          }
        }
        newErrors.dateOverlap = "";
      } else if (field === "startTime") {
        if (value) delete rowErrors.startTime;
        const endTime = drawalModals[modalIndex][rowIndex].endTime;
        if (endTime && isValidEndTime(endTime)) {
          if (value && !isTimeValid(value, endTime)) {
            rowErrors.endTime = "End time must be later";
          } else {
            delete rowErrors.endTime;
          }
        }
        newErrors.dateOverlap = "";
      } else if (field === "startDate" || field === "endDate") {
        if (value) {
          delete rowErrors[field];
          const currentRow = drawalModals[modalIndex][rowIndex];
          const startDate =
            field === "startDate" ? value : currentRow.startDate;
          const endDate = field === "endDate" ? value : currentRow.endDate;
          if (startDate && endDate) {
            const start = new Date(startDate);
            const end = new Date(endDate);
            start.setHours(0, 0, 0, 0);
            end.setHours(0, 0, 0, 0);
            if (start <= end) {
              delete rowErrors.startDate;
              delete rowErrors.endDate;
            }
          }
          newErrors.dateOverlap = "";
        }
      } else if (value && field !== "quantity") {
        delete rowErrors[field];
        newErrors.dateOverlap = "";
        newErrors.termsExpiryDate = "";
        newErrors.termsExpiryTime = "";
        newErrors.expiryDate = "";
        newErrors.expiryTime = "";
      }

      return newErrors;
    });
  };

  const addInjectionModal = () =>
    setInjectionModals((prev) => [...prev, [{ ...defaultRow }]]);
  const removeInjectionModal = (indexToRemove) =>
    setInjectionModals((prev) =>
      prev.filter((_, idx) => idx !== indexToRemove),
    );
  const addDrawalModal = () =>
    setDrawalModals((prev) => [...prev, [{ ...defaultRow }]]);
  const removeDrawalModal = (indexToRemove) =>
    setDrawalModals((prev) => prev.filter((_, idx) => idx !== indexToRemove));

  const addInjectionRow = (modalIndex) => {
    setInjectionModals((prev) =>
      prev.map((modalRows, idx) =>
        idx === modalIndex ? [...modalRows, { ...defaultRow }] : modalRows,
      ),
    );
  };

  const removeInjectionRow = (modalIndex, rowIndex) => {
    setInjectionModals((prev) =>
      prev.map((modalRows, idx) => {
        if (idx !== modalIndex) return modalRows;
        const newRows = modalRows.filter((_, rIdx) => rIdx !== rowIndex);
        return newRows.length > 0 ? newRows : [{ ...defaultRow }];
      }),
    );
  };

  const addDrawalRow = (modalIndex) => {
    setDrawalModals((prev) =>
      prev.map((modalRows, idx) =>
        idx === modalIndex ? [...modalRows, { ...defaultRow }] : modalRows,
      ),
    );
  };

  const removeDrawalRow = (modalIndex, rowIndex) => {
    setDrawalModals((prev) =>
      prev.map((modalRows, idx) => {
        if (idx !== modalIndex) return modalRows;
        const newRows = modalRows.filter((_, rIdx) => rIdx !== rowIndex);
        return newRows.length > 0 ? newRows : [{ ...defaultRow }];
      }),
    );
  };

  const handleFileChange = async (selectedFileData, event = null) => {
    if (!selectedFileData?.name) {
      if (event) {
        event.target.value = null;
      }
      return;
    }
    const formData = new FormData();
    formData.append("file", selectedFileData);
    try {
      const response = await uploadTC(formData);
      const fileId = response?.data?.data?.id;
      const fileName = response?.data?.data?.filename ?? selectedFileData?.name;
      if (!fileId) throw new Error("Failed to upload file");
      setFileValue({ id: fileId, fileName });

      // Clear any file-related errors
      setErrors((prev) => {
        const newErrors = { ...prev };
        if (newErrors.fileValue) delete newErrors.fileValue;
        return newErrors;
      });
    } catch (err) {
      setFileValue({ error: "Upload failed. Please try again." });
    }
  };

  function extractData(arr, head) {
    for (const row of arr) {
      if (row.length > 2 && row[1] === head) {
        return row[2];
      }
    }
    return null;
  }

  const handleChange = (e) => {
    const newCheckedValue = e.target.checked;

    if (!newCheckedValue) {
      // User is unchecking - show confirmation
      // setIsTermsByPass(true);
      // setConfirmToggleOpen(true);
      setChecked(false);
    } else {
      setChecked(true);
      hasUserModifiedTcApprovalRef.current = true;
    }
  };

  const formatToTwoDecimals = (val) => {
    if (val === undefined || val === null || val === "") return "";
    const num = Number(val);
    if (isNaN(num)) return "";
    return num.toFixed(2);
  };

  const handleInjectFirst = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    setExcelFileName(file.name);
    if (event.target) {
      event.target.value = null;
    }

    const excelSerialDateToJSDate = (serial) => {
      if (!serial) return "";
      const msPerDay = 24 * 60 * 60 * 1000;
      const date = new Date(Math.round((serial - 25569) * msPerDay));
      if (isNaN(date.getTime())) return "";
      const year = date.getUTCFullYear();
      const month = String(date.getUTCMonth() + 1).padStart(2, "0");
      const day = String(date.getUTCDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    };

    const isValidDateStr = (val) => /^\d{4}-\d{2}-\d{2}$/.test(val);

    const parseExcelDate = (val) => {
      if (!val) return "";
      if (typeof val === "number") return excelSerialDateToJSDate(val);
      if (typeof val === "string" && isValidDateStr(val)) return val;
      return "";
    };

    const parseExcelTime = (val) => {
      if (val === undefined || val === null || val === "") return "";
      if (typeof val === "number") {
        let totalSeconds = Math.round(val * 86400);
        const hours = Math.floor(totalSeconds / 3600);
        totalSeconds %= 3600;
        const minutes = Math.floor(totalSeconds / 60);
        if (hours === 24) return "24:00";
        return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(
          2,
          "0",
        )}`;
      }
      if (typeof val === "string") {
        const match = val.match(/(\d{1,2}):(\d{2})/);
        if (match) {
          return `${match[1].padStart(2, "0")}:${match[2]}`;
        }
      }
      return "";
    };

    const findValueByLabel = (dataArray, labelPart) => {
      if (!dataArray || dataArray.length === 0) return "";
      const labelLower = labelPart.toLowerCase();
      const rowIndex = dataArray.findIndex(
        (row) =>
          Array.isArray(row) &&
          row.some(
            (cell) =>
              cell && cell.toString().toLowerCase().includes(labelLower),
          ),
      );
      if (rowIndex === -1) return "";
      const row = dataArray[rowIndex];
      const labelColIndex = row.findIndex(
        (cell) => cell && cell.toString().toLowerCase().includes(labelLower),
      );
      for (let c = labelColIndex + 1; c < row.length; c++) {
        const cellValue = row[c];
        if (
          cellValue !== undefined &&
          cellValue !== null &&
          cellValue.toString().trim() !== ""
        ) {
          return cellValue.toString().trim();
        }
      }
      return "";
    };

    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, {
          type: "array",
          raw: true,
          defval: "",
        });
        const worksheet = workbook.Sheets[workbook.SheetNames[0]];
        const sheetDataArray = XLSX.utils.sheet_to_json(worksheet, {
          header: 1,
          defval: "",
        });

        // 1. Banking Factor
        let bankingFactorVal = null;
        const dateCreatedRow = sheetDataArray.find(
          (row) => row && row[0] && row[0].toString().includes("Date Created"),
        );
        if (dateCreatedRow && dateCreatedRow[2]) {
          bankingFactorVal = dateCreatedRow[2];
        } else {
          const fallbackRow = sheetDataArray[1] || [];
          if (fallbackRow[2]) bankingFactorVal = fallbackRow[2];
        }

        // 2. Other Terms
        const settlementRateVal = findValueByLabel(
          sheetDataArray,
          "Settlement_Rate",
        );
        const appTypeVal = findValueByLabel(sheetDataArray, "Application Type");
        const commentsVal = findValueByLabel(sheetDataArray, "Comments");

        // 3. Headers
        const injectionHeaderIndex = sheetDataArray.findIndex(
          (row) =>
            row &&
            row.some(
              (cell) =>
                typeof cell === "string" &&
                cell.trim() === "Injection Start Date",
            ),
        );
        const returnHeaderIndex = sheetDataArray.findIndex(
          (row) =>
            row &&
            row.some(
              (cell) =>
                typeof cell === "string" && cell.trim() === "Return Start Date",
            ),
        );

        if (injectionHeaderIndex === -1 || returnHeaderIndex === -1) {
          toast.error("Invalid File Format");
          return;
        }

        // 4. Parse Injection Raw Data
        const injectionHeaders = sheetDataArray[injectionHeaderIndex].map(
          (h) => (h ? h.toString().trim() : ""),
        );
        const injectionDataRows = sheetDataArray.slice(
          injectionHeaderIndex + 1,
          returnHeaderIndex,
        );
        const parsedInjection = injectionDataRows
          .filter((row) => row && (row[1] || row[2]))
          .map((row) => {
            const obj = {};
            injectionHeaders.forEach((h, i) => {
              if (h) obj[h] = row[i];
            });
            return obj;
          });

        // 5. Parse Return Raw Data
        const returnHeaders = sheetDataArray[returnHeaderIndex].map((h) =>
          h ? h.toString().trim() : "",
        );
        // We take a slice, but we will filter the results strictly later
        const returnDataRows = sheetDataArray.slice(
          returnHeaderIndex + 1,
          returnHeaderIndex + 50,
        );
        const parsedReturn = returnDataRows
          .filter((row) => row && (row[1] || row[2]))
          .map((row) => {
            const obj = {};
            returnHeaders.forEach((h, i) => {
              if (h) obj[h] = row[i];
            });
            return obj;
          });

        // 6. Set Metadata
        if (bankingFactorVal) {
          const factorValue = Number(bankingFactorVal) * 100;
          setBankingFactor(Number(factorValue.toFixed(2)).toString());
        }
        if (
          settlementRateVal &&
          (typeof settlementRateVal === "number" ||
            /^\d+(\.\d+)?$/.test(settlementRateVal))
        ) {
          setSettlementRate(`DAM+${settlementRateVal}`);
        } else if (settlementRateVal) {
          setSettlementRate(settlementRateVal);
        }
        if (appTypeVal) setActiveType(appTypeVal);
        if (commentsVal) setComments(commentsVal);

        // 7. Map to Slots and FILTER
        // **********************************************************
        // KEY CHANGE HERE: Added .filter() to remove invalid rows
        // **********************************************************

        const injectionSlots = parsedInjection
          .map((item) => ({
            startDate: parseExcelDate(item["Injection Start Date"]),
            endDate: parseExcelDate(item["Injection End Date"]),
            startTime: parseExcelTime(item["Injection Start Time"]),
            endTime: parseExcelTime(item["Injection End Time"]),
            quantity: formatToTwoDecimals(item["Injection Quantum (MW)"]),
            rtcChecked:
              parseExcelTime(item["Injection Start Time"]) === "00:00" &&
              parseExcelTime(item["Injection End Time"]) === "24:00",
          }))
          .filter(
            (slot) =>
              slot.startDate && slot.quantity && slot.quantity !== "0.00",
          );

        const drawalSlots = parsedReturn
          .map((item) => ({
            startDate: parseExcelDate(item["Return Start Date"]),
            endDate: parseExcelDate(item["Return End Date"]),
            startTime: parseExcelTime(item["Return Start Time"]),
            endTime: parseExcelTime(item["Return End Time"]),
            quantity: formatToTwoDecimals(
              item["Return Quantum (MW)"] || item["Drawal Quantum (MW)"],
            ),
            rtcChecked:
              parseExcelTime(item["Return Start Time"]) === "00:00" &&
              parseExcelTime(item["Return End Time"]) === "24:00",
          }))
          .filter(
            (slot) =>
              slot.startDate && slot.quantity && slot.quantity !== "0.00",
          );

        const emptySlot = {
          startTime: "",
          endTime: "",
          startDate: "",
          endDate: "",
          quantity: "",
          rtcChecked: false,
        };

        setInjectionModals(
          injectionSlots.length > 0
            ? injectionSlots.map((slot) => [slot])
            : [[emptySlot]],
        );
        setDrawalModals(
          drawalSlots.length > 0
            ? drawalSlots.map((slot) => [slot])
            : [[emptySlot]],
        );

        setErrors({});
        toast.success("Excel imported successfully!");
      } catch (error) {
        console.error("Processing Error:", error);
        toast.error("Error processing file.");
      }
    };
    reader.readAsArrayBuffer(file);
  };

  const handleDrawalFirst = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    setExcelFileName(file.name);
    if (event.target) {
      event.target.value = null;
    }

    // --- Helper Functions ---
    const excelSerialDateToJSDate = (serial) => {
      if (!serial) return "";
      const msPerDay = 24 * 60 * 60 * 1000;
      const date = new Date(Math.round((serial - 25569) * msPerDay));
      if (isNaN(date.getTime())) return "";
      const year = date.getUTCFullYear();
      const month = String(date.getUTCMonth() + 1).padStart(2, "0");
      const day = String(date.getUTCDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    };

    const isValidDateStr = (val) => /^\d{4}-\d{2}-\d{2}$/.test(val);

    const parseExcelDate = (val) => {
      if (!val) return "";
      if (typeof val === "number") return excelSerialDateToJSDate(val);
      if (typeof val === "string" && isValidDateStr(val)) return val;
      return "";
    };

    const parseExcelTime = (val) => {
      if (val === undefined || val === null || val === "") return "";
      if (typeof val === "number") {
        let totalSeconds = Math.round(val * 86400);
        const hours = Math.floor(totalSeconds / 3600);
        totalSeconds %= 3600;
        const minutes = Math.floor(totalSeconds / 60);
        if (hours === 24) return "24:00";
        return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(
          2,
          "0",
        )}`;
      }
      if (typeof val === "string") {
        const match = val.match(/(\d{1,2}):(\d{2})/);
        if (match) {
          return `${match[1].padStart(2, "0")}:${match[2]}`;
        }
      }
      return "";
    };

    const findValueByLabel = (dataArray, labelPart) => {
      if (!dataArray || dataArray.length === 0) return "";
      const labelLower = labelPart.toLowerCase();

      const rowIndex = dataArray.findIndex(
        (row) =>
          Array.isArray(row) &&
          row.some(
            (cell) =>
              cell && cell.toString().toLowerCase().includes(labelLower),
          ),
      );
      if (rowIndex === -1) return "";

      const row = dataArray[rowIndex];
      const labelColIndex = row.findIndex(
        (cell) => cell && cell.toString().toLowerCase().includes(labelLower),
      );

      for (let c = labelColIndex + 1; c < row.length; c++) {
        const cellValue = row[c];
        if (
          cellValue !== undefined &&
          cellValue !== null &&
          cellValue.toString().trim() !== ""
        ) {
          return cellValue.toString().trim();
        }
      }
      return "";
    };

    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, {
          type: "array",
          raw: true,
          defval: "",
        });

        const mainSheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[mainSheetName];
        const sheetDataArray = XLSX.utils.sheet_to_json(worksheet, {
          header: 1,
          defval: "",
        });

        // 1. Extract Banking Factor
        // "Date Created" row usually has BF in column C (index 2)
        let bankingFactorVal = null;
        const dateCreatedRow = sheetDataArray.find(
          (row) => row && row[0] && row[0].toString().includes("Date Created"),
        );
        if (dateCreatedRow && dateCreatedRow[2]) {
          bankingFactorVal = dateCreatedRow[2];
        } else {
          const fallbackRow = sheetDataArray[1] || [];
          if (fallbackRow[2]) bankingFactorVal = fallbackRow[2];
        }

        // 2. Other Terms
        const settlementRateVal = findValueByLabel(
          sheetDataArray,
          "Settlement_Rate",
        );
        const appTypeVal = findValueByLabel(sheetDataArray, "Application Type");
        const commentsVal = findValueByLabel(sheetDataArray, "Comments");

        // 3. Locate Headers (Using spaces to match new file format)
        const drawalHeaderIndex = sheetDataArray.findIndex(
          (row) =>
            row &&
            row.some(
              (cell) =>
                typeof cell === "string" && cell.trim() === "Drawal Start Date",
            ),
        );

        const returnHeaderIndex = sheetDataArray.findIndex(
          (row) =>
            row &&
            row.some(
              (cell) =>
                typeof cell === "string" && cell.trim() === "Return Start Date",
            ),
        );

        if (drawalHeaderIndex === -1 || returnHeaderIndex === -1) {
          toast.error(
            "Invalid File Format: Could not find 'Drawal Start Date' or 'Return Start Date'.",
          );
          return;
        }

        // 4. Parse Drawal Data
        const drawalHeaders = sheetDataArray[drawalHeaderIndex].map((h) =>
          h ? h.toString().trim() : "",
        );

        // Rows between Drawal header and Return header
        const drawalDataRows = sheetDataArray.slice(
          drawalHeaderIndex + 1,
          returnHeaderIndex,
        );

        const parsedDrawal = drawalDataRows
          .filter((row) => row && (row[1] || row[2])) // Basic check for content
          .map((row) => {
            const obj = {};
            drawalHeaders.forEach((h, i) => {
              if (h) obj[h] = row[i];
            });
            return obj;
          });

        // 5. Parse Return Data
        const returnHeaders = sheetDataArray[returnHeaderIndex].map((h) =>
          h ? h.toString().trim() : "",
        );

        // Grab rows after Return Header
        const returnDataRows = sheetDataArray.slice(
          returnHeaderIndex + 1,
          returnHeaderIndex + 50,
        );

        const parsedReturn = returnDataRows
          .filter((row) => row && (row[1] || row[2]))
          .map((row) => {
            const obj = {};
            returnHeaders.forEach((h, i) => {
              if (h) obj[h] = row[i];
            });
            return obj;
          });

        // 6. Map and Filter Slots (Strict Filtering)
        const drawalSlots = parsedDrawal
          .map((item) => ({
            startDate: parseExcelDate(item["Drawal Start Date"]),
            endDate: parseExcelDate(item["Drawal End Date"]),
            startTime: parseExcelTime(item["Drawal Start Time"]),
            endTime: parseExcelTime(item["Drawal End Time"]),
            quantity: formatToTwoDecimals(item["Drawal Quantum (MW)"]),

            rtcChecked:
              parseExcelTime(item["Drawal Start Time"]) === "00:00" &&
              parseExcelTime(item["Drawal End Time"]) === "24:00",
          }))
          // STRICT FILTER: Must have Start Date AND Quantity
          .filter(
            (slot) =>
              slot.startDate && slot.quantity && slot.quantity !== "0.00",
          );

        // In "Drawal First" context, the Return section maps to injectionSlots
        const injectionSlots = parsedReturn
          .map((item) => ({
            startDate: parseExcelDate(item["Return Start Date"]),
            endDate: parseExcelDate(item["Return End Date"]),
            startTime: parseExcelTime(item["Return Start Time"]),
            endTime: parseExcelTime(item["Return End Time"]),
            quantity: formatToTwoDecimals(item["Return Quantum (MW)"]),

            rtcChecked:
              parseExcelTime(item["Return Start Time"]) === "00:00" &&
              parseExcelTime(item["Return End Time"]) === "24:00",
          }))
          // STRICT FILTER
          .filter(
            (slot) =>
              slot.startDate && slot.quantity && slot.quantity !== "0.00",
          );

        // 7. Set State
        if (bankingFactorVal) {
          const factorValue = Number(bankingFactorVal) * 100;
          setBankingFactor(Number(factorValue.toFixed(2)).toString());
        }

        if (
          settlementRateVal &&
          (typeof settlementRateVal === "number" ||
            /^\d+(\.\d+)?$/.test(settlementRateVal))
        ) {
          setSettlementRate(`DAM+${settlementRateVal}`);
        } else if (settlementRateVal) {
          setSettlementRate(settlementRateVal);
        }

        if (appTypeVal) setActiveType(appTypeVal);
        if (commentsVal) setComments(commentsVal);

        const emptySlot = {
          startTime: "",
          endTime: "",
          startDate: "",
          endDate: "",
          quantity: "",
          rtcChecked: false,
        };

        setDrawalModals(
          drawalSlots.length > 0
            ? drawalSlots.map((slot) => [slot])
            : [[emptySlot]],
        );
        setInjectionModals(
          injectionSlots.length > 0
            ? injectionSlots.map((slot) => [slot])
            : [[emptySlot]],
        );

        setErrors({});
        toast.success("Drawal First data imported successfully!");
      } catch (error) {
        console.error("Fatal Error processing Drawal file:", error);
        toast.error("A fatal error occurred during file processing.");
      }
    };
    reader.readAsArrayBuffer(file);
  };

  const clearAllFormInputs = () => {
    setInjectionModals([[{ ...defaultRow }]]);
    setDrawalModals([[{ ...defaultRow }]]);

    setBankingFactor("");
    setSettlementRate("DAM+");
    setActiveType("GNA");
    setExpiryDate("");
    setExpiryTime("");
    setTermsExpiryDate("");
    setTermsExpiryTime("");
    setComments("");
    setIsInjectionOnTop(true);

    setErrors({
      expiryDate: "",
      expiryTime: "",
      termsExpiryDate: "",
      termsExpiryTime: "",
      injectionModals: [],
      drawalModals: [],
      bankingFactor: "",
      settlementRate: "",
      comments: "",
    });
    if (editedQuantitiesRef && editedQuantitiesRef.current) {
      editedQuantitiesRef.current.clear();
    }
  };

  const handleRemoveExcelFile = () => {
    setExcelFileName("");
    setExcelFileData(null);
    clearAllFormInputs();
    const fileInput = document.getElementById("excelFileUpload");
    if (fileInput) {
      fileInput.value = "";
    }
  };

  const handleRemoveTCFile = () => {
    setFileValue(null);
    setTcFileData(null);
    setTcFileName("");

    const fileInput = document.getElementById("ledgerFileUpload");
    if (fileInput) {
      fileInput.value = "";
    }
  };

  const handleBankingFactorChange = (val) => {
    setBankingFactor(val);
    const numVal = Number(val);
    if (!isNaN(numVal) && numVal >= 100) {
      setErrors((errors) => clearFieldError(errors, "bankingFactor"));
    }
  };

  const handleSettlementRateChange = (val) => {
    let value = String(val || "");
    if (value === "") {
      setSettlementRate("");
      return;
    }
    if (!value.startsWith("DAM")) {
      if (/^\d*\.?\d*$/.test(value)) {
        value = "DAM+" + value;
      } else {
        return;
      }
    }
    if (value === "D" || value === "DA" || value === "DAM") {
      setSettlementRate(value);
      return;
    }
    if (value.startsWith("DAM")) {
      const afterDAM = value.slice(3);

      if (afterDAM === "") {
        setSettlementRate("DAM");
        return;
      }
      if (afterDAM.startsWith("+") || afterDAM.startsWith("-")) {
        const sign = afterDAM[0];
        let numericPart = afterDAM.slice(1);

        if (numericPart === "") {
          setSettlementRate("DAM" + sign);
          return;
        }

        const parts = numericPart.split(".");
        if (parts.length > 2) {
          return;
        }

        if (parts.length === 2 && parts[1].length > 3) {
          numericPart = parts[0] + "." + parts[1].substring(0, 3);
        }

        const num = parseFloat(numericPart);
        if (!isNaN(num)) {
          if (num > 9) {
            return;
          }

          const finalValue = "DAM" + sign + numericPart;
          setSettlementRate(finalValue);

          if (
            /^DAM[+-]\d+(\.\d{1,3})?$/.test(finalValue) &&
            num >= 1 &&
            num <= 9
          ) {
            setErrors((errors) => clearFieldError(errors, "settlementRate"));
          }
          return;
        }

        setSettlementRate("DAM" + sign + numericPart);
      } else {
        let numericPart = afterDAM;

        const parts = numericPart.split(".");
        if (parts.length > 2) {
          return;
        }

        if (parts.length === 2 && parts[1].length > 3) {
          numericPart = parts[0] + "." + parts[1].substring(0, 3);
        }

        const num = parseFloat(numericPart);
        if (!isNaN(num)) {
          if (num > 9) {
            return;
          }

          const finalValue = "DAM+" + numericPart;
          setSettlementRate(finalValue);

          if (
            /^DAM[+-]\d+(\.\d{1,3})?$/.test(finalValue) &&
            num >= 1 &&
            num <= 9
          ) {
            setErrors((errors) => clearFieldError(errors, "settlementRate"));
          }
          return;
        }

        setSettlementRate("DAM+" + numericPart);
      }
    }
    setSettlementRate(value);
  };

  const handleSettlementRateSignChange = (newSign) => {
    const currentNumericPart = settlementRate.slice(4);
    const newValue = "DAM" + newSign + currentNumericPart;
    setSettlementRate(newValue);

    if (currentNumericPart && Number(currentNumericPart) >= 1) {
      setErrors((errors) => clearFieldError(errors, "settlementRate"));
    }
  };

  const handleExpiryDateChange = (val) => {
    setExpiryDate(val);
    setExpiryAuto(false);
    setErrors((errors) => clearFieldError(errors, "expiryDate"));
  };

  const handleExpiryTimeChange = (val) => {
    setExpiryTime(val);
    setExpiryAuto(false);
    setErrors((errors) => clearFieldError(errors, "expiryTime"));
  };
  const handleTermsExpiryDateChange = (date) => {
    setTermsExpiryDate(date);
    setErrors((errors) => clearFieldError(errors, "termsExpiryDate"));
  };
  const handleTermsExpiryTimeChange = (date) => {
    setTermsExpiryTime(date);
    setErrors((errors) => clearFieldError(errors, "termsExpiryTime"));
  };

  const handleSubmitClick = async () => {
    if (isLoading) return;

    const validationErrors = validateForm();

    const rowHasMessage = (row) =>
      row &&
      Object.values(row).some((v) => typeof v === "string" && v.trim() !== "");

    const hasStringErrors = Object.keys(validationErrors).some(
      (key) =>
        key !== "injectionModals" &&
        key !== "drawalModals" &&
        typeof validationErrors[key] === "string" &&
        validationErrors[key].trim() !== "",
    );

    const hasInjectionErrors =
      Array.isArray(validationErrors.injectionModals) &&
      validationErrors.injectionModals.some(
        (modal) =>
          Array.isArray(modal) && modal.some((row) => rowHasMessage(row)),
      );

    const hasDrawalErrors =
      Array.isArray(validationErrors.drawalModals) &&
      validationErrors.drawalModals.some(
        (modal) =>
          Array.isArray(modal) && modal.some((row) => rowHasMessage(row)),
      );

    const hasErrors = hasStringErrors || hasInjectionErrors || hasDrawalErrors;

    if (!acceptSystemTerms) {
      toast.error("Please accept the System Terms and Conditions");
      setErrors(validationErrors);
      return;
    }

    if (hasErrors) {
      setErrors(validationErrors);
      return;
    }

    if (!prefilledData?.id) {
      console.error("Missing againstBankingListingId in prefilledData");
      toast.error("Invalid listing data. Please refresh and try again.");
      return;
    }

    setErrors({ injectionModals: [], drawalModals: [] });
    setIsLoading(true);

    try {
      const flattenedDrawals = drawalModals
        .filter((modal) => Array.isArray(modal) && modal.length > 0)
        .flat()
        .filter((slot) => slot && typeof slot === "object");

      const flattenedInjections = injectionModals
        .filter((modal) => Array.isArray(modal) && modal.length > 0)
        .flat()
        .filter((slot) => slot && typeof slot === "object");

      const payload = {
        tenderDocumentId: 0,
        energyTypeId: 0,
        deliveryPoint: "",
        lossAdjustment: null,
        gnaepleListing: activeType,
        termsDocumentId: fileValue?.id || docId || null,
        comments: comments || "",
        settlementRate,
        requiredQty: 0,
        minimumQty: 0,
        minimumSlots: 0,
        bankingFactor: Number(bankingFactor) || 0,
        termsExpiryAt:
          finalTermsExpiryDate && finalTermsExpiryTime
            ? formatExpiryAt(finalTermsExpiryDate, finalTermsExpiryTime)
            : null,
        injectRangeLossAdjustment: "",
        isTradingMarginInject: true,
        tradingMarginInject: 0,
        expiryAt: formatExpiryAt(expiryDate, expiryTime),
        status: "ACTIVE",
        bankingSlotDrawls: transformSlots(flattenedDrawals),
        bankingSlotInjects: transformSlots(flattenedInjections),
        isInjectionOnTop: isInjectionOnTop,
        termsByPass: checked ? 1 : 0,
      };

      const response = await createBankingList(payload, null, null);
      const newListingId = response?.data?.data?.id;

      if (!newListingId) {
        throw new Error("No listing ID returned from createBankingList");
      }

      const againstBankingListingId = prefilledData.id;

      const bidResponse = await placeBid({
        bankingListingId: newListingId,
        againstBankingListingId,
      });

      const connectionId = bidResponse?.data?.data?.id;

      if (!connectionId) {
        throw new Error("No connection ID returned from placeBid");
      }

      handleClose();

      if (onSubmitSuccess) {
        onSubmitSuccess();
      }

      navigate("/banking");

      setTimeout(() => {
        window.location.reload();
      });
    } catch (err) {
      console.error(" Error in handleSubmitClick:", err);

      const errorMessage =
        err?.response?.data?.message ||
        err?.message ||
        "Something went wrong. Please try again.";

      toast.error(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (!open) return;

    if (expiryDate && !expiryAuto) return;

    const allSlots = [
      ...(injectionModals || []).flat(),
      ...(drawalModals || []).flat(),
    ];

    const dateTimes = [];
    allSlots.forEach((slot) => {
      if (slot.startDate && slot.startTime) {
        const dt = new Date(slot.startDate);
        const [h, m] = (slot.startTime || "").split(":").map(Number);
        if (!isNaN(h) && !isNaN(m)) dt.setHours(h, m, 0, 0);
        dateTimes.push(dt.getTime());
      } else if (slot.startDate) {
        const dt = new Date(slot.startDate);
        dt.setHours(0, 0, 0, 0);
        if (!isNaN(dt.getTime())) dateTimes.push(dt.getTime());
      }
    });

    if (!dateTimes.length) {
    } else {
      const minStart = new Date(Math.min(...dateTimes));

      const startDateOnly = new Date(
        minStart.getFullYear(),
        minStart.getMonth(),
        minStart.getDate(),
      );
      const todayOnly = new Date();
      todayOnly.setHours(0, 0, 0, 0);

      if (+startDateOnly === +todayOnly) {
        const expiryDt = new Date(minStart.getTime() - 3 * 60 * 60 * 1000);
        const year = String(minStart.getFullYear());
        const month = String(minStart.getMonth() + 1).padStart(2, "0");
        const day = String(minStart.getDate()).padStart(2, "0");
        const hours = String(expiryDt.getHours()).padStart(2, "0");
        const minutes = String(expiryDt.getMinutes()).padStart(2, "0");
        setExpiryDate(`${year}-${month}-${day}`);
        setExpiryTime(`${hours}:${minutes}`);
      } else {
        const expiryDt = new Date(minStart.getTime() - 3 * 60 * 60 * 1000);
        const year = expiryDt.getFullYear();
        const month = String(expiryDt.getMonth() + 1).padStart(2, "0");
        const day = String(expiryDt.getDate()).padStart(2, "0");
        const hours = String(expiryDt.getHours()).padStart(2, "0");
        const minutes = String(expiryDt.getMinutes()).padStart(2, "0");
        setExpiryDate(`${year}-${month}-${day}`);
        setExpiryTime(`${hours}:${minutes}`);
      }

      const termsExpiryDt = new Date(minStart.getTime() - 2 * 60 * 60 * 1000);
      const termsYear = termsExpiryDt.getFullYear();
      const termsMonth = String(termsExpiryDt.getMonth() + 1).padStart(2, "0");
      const termsDay = String(termsExpiryDt.getDate()).padStart(2, "0");
      const termsHours = String(termsExpiryDt.getHours()).padStart(2, "0");
      const termsMinutes = String(termsExpiryDt.getMinutes()).padStart(2, "0");
      setTermsExpiryDate(`${termsYear}-${termsMonth}-${termsDay}`);
      setTermsExpiryTime(`${termsHours}:${termsMinutes}`);
      setExpiryAuto(true);
    }

    const factor = Number(bankingFactor) || 0;
    if (factor <= 0) return;

    const computeSlotHours = (slot) => {
      const days =
        slot.startDate && slot.endDate
          ? (new Date(slot.endDate) - new Date(slot.startDate)) /
              (1000 * 60 * 60 * 24) +
            1
          : 0;
      const totalHrs = calculateTotalHoursSafe(
        slot.startTime,
        slot.endTime,
        slot.rtcChecked,
      );

      return days * totalHrs;
    };

    if (isInjectionOnTop) {
      let totalInjectionMwh = 0;
      injectionModals.forEach((modal) =>
        modal.forEach((slot) => {
          const qty = Number(slot.quantity) || 0;
          totalInjectionMwh += qty * computeSlotHours(slot);
        }),
      );

      let fixedDrawalMwh = 0;
      const autoSlots = [];
      drawalModals.forEach((modal, mi) =>
        modal.forEach((slot, si) => {
          const hours = computeSlotHours(slot);
          const key = `dra-${mi}-${si}`;
          const qty =
            slot.quantity !== undefined &&
            slot.quantity !== null &&
            String(slot.quantity).trim() !== ""
              ? Number(slot.quantity)
              : null;
          if (qty !== null && !isNaN(qty)) {
            fixedDrawalMwh += qty * hours;
          } else if (hours > 0 && !editedQuantitiesRef.current.has(key)) {
            autoSlots.push({ mi, si, hours });
          }
        }),
      );

      const desiredTotalDrawalMwh = (totalInjectionMwh * factor) / 100;
      const remainingMwhNeeded = desiredTotalDrawalMwh - fixedDrawalMwh;

      if (autoSlots.length === 0) return;
      const sumAutoHours = autoSlots.reduce((s, a) => s + a.hours, 0);
      if (sumAutoHours <= 0) return;

      const qtyForEachAutoSlot = Math.max(0, remainingMwhNeeded / sumAutoHours);

      setDrawalModals((prev) =>
        prev.map((modal, mi) =>
          modal.map((slot, si) => {
            const key = `dra-${mi}-${si}`;
            const hasValue =
              slot.quantity !== undefined &&
              slot.quantity !== null &&
              String(slot.quantity).trim() !== "";
            if (hasValue || editedQuantitiesRef.current.has(key)) return slot;
            const info = autoSlots.find((a) => a.mi === mi && a.si === si);
            if (!info) return slot;
            return { ...slot, quantity: qtyForEachAutoSlot.toFixed(2) };
          }),
        ),
      );
    } else {
      let totalDrawalMwh = 0;
      drawalModals.forEach((modal) =>
        modal.forEach((slot) => {
          const qty = Number(slot.quantity) || 0;
          totalDrawalMwh += qty * computeSlotHours(slot);
        }),
      );
      let fixedInjectionMwh = 0;
      const autoSlots = [];
      injectionModals.forEach((modal, mi) =>
        modal.forEach((slot, si) => {
          const hours = computeSlotHours(slot);
          const key = `inj-${mi}-${si}`;
          const qty =
            slot.quantity !== undefined &&
            slot.quantity !== null &&
            String(slot.quantity).trim() !== ""
              ? Number(slot.quantity)
              : null;
          if (qty !== null && !isNaN(qty)) {
            fixedInjectionMwh += qty * hours;
          } else if (hours > 0 && !editedQuantitiesRef.current.has(key)) {
            autoSlots.push({ mi, si, hours });
          }
        }),
      );

      const desiredTotalInjectionMwh =
        factor > 0 ? (totalDrawalMwh * factor) / 100 : 0;
      const remainingMwhNeeded = desiredTotalInjectionMwh - fixedInjectionMwh;

      if (autoSlots.length === 0) return;
      const sumAutoHours = autoSlots.reduce((s, a) => s + a.hours, 0);
      if (sumAutoHours <= 0) return;

      const qtyForEachAutoSlot = Math.max(0, remainingMwhNeeded / sumAutoHours);
      setInjectionModals((prev) =>
        prev.map((modal, mi) =>
          modal.map((slot, si) => {
            const key = `inj-${mi}-${si}`;
            const hasValue =
              slot.quantity !== undefined &&
              slot.quantity !== null &&
              String(slot.quantity).trim() !== "";
            if (hasValue || editedQuantitiesRef.current.has(key)) return slot;
            const info = autoSlots.find((a) => a.mi === mi && a.si === si);
            if (!info) return slot;
            return { ...slot, quantity: qtyForEachAutoSlot.toFixed(2) };
          }),
        ),
      );
    }
  }, [
    injectionModals,
    drawalModals,
    bankingFactor,
    isInjectionOnTop,
    open,
    expiryDate,
  ]);

  const handleCommentsChange = (text) => {
    if (text.length > 200) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        comments: "Comments cannot be more than 200 characters",
      }));
      setComments(text.slice(0, 200));
      return;
    } else {
      setErrors((prevErrors) => {
        const newErrors = { ...prevErrors };
        delete newErrors.comments;
        return newErrors;
      });
    }

    const words = text.trim().split(/\s+/);
    if (words.length <= 50) {
      setComments(text);
    } else {
      const limitedText = words.slice(0, 50).join(" ");
      setComments(limitedText);
    }
  };

  async function handleDownloadExcel() {
    const today = new Date();

    const formattedDate = [
      String(today.getDate()).padStart(2, "0"),
      String(today.getMonth() + 1).padStart(2, "0"),
      today.getFullYear(),
    ].join("-");

    const fileUrl = isInjectionOnTop ? BankingInjectFirst : BankingDrawFirst;

    const fileName = isInjectionOnTop
      ? `BankingInjectFirst_${formattedDate}.xlsx`
      : `BankingDrawalFirst_${formattedDate}.xlsx`;

    try {
      const response = await fetch(fileUrl);
      const blob = await response.blob();

      saveAs(
        new Blob([blob], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        }),
        fileName,
      );
    } catch (error) {
      console.error("Excel download failed:", error);
    }
  }

  useEffect(() => {
    const defaultRow = {
      startTime: "",
      endTime: "",
      startDate: "",
      endDate: "",
      quantity: "",
      rtcChecked: false,
    };

    if (open && prefilledData) {
      if (prefilledData.isInjectionOnTop !== undefined) {
        setIsInjectionOnTop(prefilledData.isInjectionOnTop);
      }
      if (prefilledData.termsByPass !== undefined) {
        setChecked(prefilledData.termsByPass ? 1 : 0);
      }
      const wrapSlots = (slots) => {
        if (!Array.isArray(slots)) return [[{ ...defaultRow }]];

        const ensureRTCDetection = (slot) => {
          const processedSlot = { ...slot };

          const shouldBeRTC =
            processedSlot.startTime === "00:00" &&
            (processedSlot.endTime === "24:00" ||
              processedSlot.endTime === "23:59");

          processedSlot.rtcChecked = shouldBeRTC;
          return processedSlot;
        };

        if (
          Array.isArray(slots[0]) &&
          slots[0].length > 0 &&
          typeof slots[0][0] === "object"
        ) {
          if (slots.length === 1 && slots[0].length > 1) {
            return slots[0].map((slot) => [ensureRTCDetection(slot)]);
          }
          return slots.map((modalSlots) => modalSlots.map(ensureRTCDetection));
        }
        return slots.map((slot) => [ensureRTCDetection(slot)]);
      };
      setInjectionModals(wrapSlots(prefilledData.injectionSlots));
      setDrawalModals(wrapSlots(prefilledData.drawalSlots));
      setBankingFactor(prefilledData.bankingFactor || "");
      setSettlementRate(prefilledData.settlementRate || "");
      setComments(prefilledData.comments || "");
      setExpiryDate(prefilledData.expiryDate || "");
      setExpiryTime(prefilledData.expiryTime || "");
      setTermsExpiryDate(prefilledData.termsExpiryDate || "");
      setTermsExpiryTime(prefilledData.termsExpiryTime || "");
      setActiveType(prefilledData.activeType || "GNA");

      // Disable auto-calculation when loading prefilled data
      if (prefilledData.expiryDate && prefilledData.expiryTime) {
        setExpiryAuto(false);
      }
    } else if (!open) {
      setIsInjectionOnTop(true);
    }
  }, [open, prefilledData]);
  return (
    <>
      <ConfirmationModal
        open={confirmToggleOpen}
        handleClose={() => {
          setSubmitConfirmModalOpen(false);
          setConfirmToggleOpen(false);
        }}
        header={
          submitConfirmModalOpen
            ? checked
              ? "Confirm Listing T&C"
              : "Submit Banking Listing"
            : "Change Banking View"
        }
        data={
          submitConfirmModalOpen
            ? checked
              ? "A new listing will be created."
              : "Are you sure you want to submit this listing? Please confirm that all the details are correct before submitting.\n"
            : nextIsInjectionOnTop
              ? "Do you want to switch to Power Injection First?\n"
              : "Do you want to switch to Power Drawal First?\n"
        }
        note={
          submitConfirmModalOpen
            ? checked
              ? "You have selected “Confirm Listing T&C.” If a 100% matched connection request is accepted, the listing details will constitute the Final Terms & Conditions agreed upon by both parties, and the parties may directly proceed with the required documentation.\n\n Do you want to proceed?"
              : "Before submitting please review all the details.\n"
            : nextIsInjectionOnTop
              ? "Switching will reset the entries for power Drawal data."
              : "Switching will reset the entries for power Injection data"
        }
        handleSubmit={() => {
          setSubmitConfirmModalOpen(false);
          setConfirmToggleOpen(false);
          if (submitConfirmModalOpen) {
            handleSubmitClick();
          } else {
            setIsInjectionOnTop(nextIsInjectionOnTop);

            setInjectionModals([[{ ...defaultRow }]]);
            setDrawalModals([[{ ...defaultRow }]]);
            setBankingFactor("");
            setSettlementRate("");
            setFileValue(null);
            setTcFileData(null);
            setTcFileName("");
            setExcelFileName("");
            setComments("");
            setExpiryDate("");
            setExpiryTime("");
            setTermsExpiryDate("");
            setTermsExpiryTime("");
            setErrors({});
            setPreviewModal(false);
            setPreviewFileUrl(null);
            hasUserModifiedTcApprovalRef.current = false;
          }

          try {
            if (editedQuantitiesRef && editedQuantitiesRef.current)
              editedQuantitiesRef.current.clear();
          } catch (e) {}

          setConfirmToggleOpen(false);
        }}
        loading={false}
      />
      <PdfPreviewModal />

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
      >
        <div className={`popupModal ${Styles.createEditModalCont}`}>
          <div
            className={`display_flex_row modalHeading ${Styles.modalHeading}`}
          >
            <div className="headingText">Connect to Banking Listing</div>
            <Close
              style={{ fontSize: 24, color: "#777777", cursor: "pointer" }}
              onClick={handleClose}
            />
          </div>
          <div
            className={`scroll_bar_y display_flex_column_gap_8 ${Styles.bankingInputMainContainer}`}
          >
            <div className={`display_flex_row ${Styles.uploadSection}`}>
              <div>
                {" "}
                <div
                  style={{
                    display: "flex",
                    border: "1px solid #FFFFFF",
                    borderRadius: "24px",
                    overflow: "hidden",
                    backgroundColor: "#FAFAFA",
                    boxShadow:
                      "2px 2px 8.8px #0000000A, inset 0px 2px 4px #00000021",
                  }}
                >
                  <div
                    onClick={() => {
                      setNextIsInjectionOnTop(true);
                      setConfirmToggleOpen(true);
                    }}
                    style={{
                      padding: "8px 10px",
                      cursor: "pointer",
                      backgroundColor: isInjectionOnTop
                        ? "#FFFFFF"
                        : "transparent",
                      color: isInjectionOnTop ? "#F1935c" : "#6F6D7C",
                      fontWeight: isInjectionOnTop ? "500" : "400",
                      boxShadow: isInjectionOnTop
                        ? "6.07px 6.07px 16.2px #0000000D"
                        : "none",
                      fontSize: "12px",
                      transition: "all 0.3s ease",
                      borderRadius: "20px",
                    }}
                  >
                    Injection
                  </div>
                  <div
                    onClick={() => {
                      setNextIsInjectionOnTop(false);
                      setConfirmToggleOpen(true);
                    }}
                    style={{
                      padding: "8px 10px",
                      cursor: "pointer",
                      backgroundColor: !isInjectionOnTop
                        ? "#FFFFFF"
                        : "transparent",
                      color: !isInjectionOnTop ? "#F1935c" : "#6F6D7C",
                      fontWeight: !isInjectionOnTop ? "500" : "400",
                      boxShadow: !isInjectionOnTop
                        ? "6.07px 6.07px 16.2px #0000000D"
                        : "none",
                      fontSize: "12px",
                      transition: "all 0.3s ease",
                      borderRadius: "20px",
                    }}
                  >
                    Drawal
                  </div>
                </div>
              </div>
              <div className={` ${Styles.uploadOtherSection}`}>
                <div className={Styles.excelMainContainer}>
                  <div></div>
                  <div className={Styles.customFileUploadExcel}>
                    <label
                      htmlFor="excelFileUpload"
                      className={Styles.uploadLabel}
                      style={{
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                      }}
                    >
                      {excelFileName ? (
                        <div
                          className="display_flex_row"
                          style={{ width: "95%", gap: "8px" }}
                        >
                          <span className={Styles.uploadedFileNameExcel}>
                            <strong>{excelFileName}</strong>
                          </span>
                          <span
                            onClick={(e) => {
                              e.preventDefault();
                              handleRemoveExcelFile();
                            }}
                            style={{ cursor: "pointer" }}
                            title="Remove file"
                          >
                            <CrossIcon
                              style={{
                                fontSize: 16,
                                width: "13px",
                                height: "13px",
                                paddingTop: "3px",
                              }}
                            />
                          </span>
                        </div>
                      ) : (
                        <div className={Styles.uploadHeaderExcel}>
                          <span>
                            <Upload
                              width="28px"
                              height="28px"
                              display="flex"
                              justifyContent="right"
                            />
                          </span>
                          <span>
                            Upload{" "}
                            {isInjectionOnTop ? "(Injection)" : "(Drawal)"}
                          </span>
                        </div>
                      )}
                    </label>
                    <input
                      id="excelFileUpload"
                      type="file"
                      accept=".xlsx,.xls"
                      style={{ display: "none" }}
                      onChange={(e) =>
                        isInjectionOnTop
                          ? handleInjectFirst(e)
                          : handleDrawalFirst(e)
                      }
                    />
                  </div>
                </div>
                <div
                  className={`display_flex_row_gap_8 ${Styles.downloadButton}`}
                  onClick={handleDownloadExcel}
                  style={{ cursor: "pointer" }}
                >
                  <Download style={{ fontSize: 24 }} />
                  <span>Template</span>
                </div>
              </div>
            </div>

            {isInjectionOnTop ? (
              <>
                {injectionModals.map((rowArr, modalIndex) => {
                  return (
                    <div
                      key={modalIndex}
                      className={`display_flex_column_gap_4 ${Styles.injectDrawalCont}`}
                      style={{ position: "relative" }}
                    >
                      <div className={Styles.draInHeader}>
                        Injection{" "}
                        {injectionModals.length > 1 ? ` ${modalIndex + 1}` : ""}
                      </div>

                      <div className={Styles.rowsScrollableContainer}>
                        {rowArr.map((row, rowIndex) => {
                          const endTimeDisplay = transformTimeForDisplay(
                            row.endTime,
                          );
                          return (
                            <div
                              key={`${modalIndex}-${rowIndex}`}
                              className={`display_flex_row_common ${Styles.eachSelectionMainContainer}`}
                            >
                              <DateInput
                                heading="Start Date"
                                value={row.startDate}
                                minDate={today}
                                height={35}
                                maxDate={
                                  row.endDate
                                    ? new Date(row.endDate)
                                    : undefined
                                }
                                onChange={(date) =>
                                  handleInjectionChange(
                                    modalIndex,
                                    rowIndex,
                                    "startDate",
                                    date,
                                  )
                                }
                                error={
                                  errors.injectionModals?.[modalIndex]?.[
                                    rowIndex
                                  ]?.startDate
                                }
                                errorMessage={
                                  errors.injectionModals?.[modalIndex]?.[
                                    rowIndex
                                  ]?.startDate
                                }
                              />
                              <DateInput
                                heading="End Date"
                                value={row.endDate}
                                height={35}
                                minDate={
                                  row.startDate
                                    ? new Date(row.startDate)
                                    : today
                                }
                                onChange={(date) =>
                                  handleInjectionChange(
                                    modalIndex,
                                    rowIndex,
                                    "endDate",
                                    date,
                                  )
                                }
                                error={
                                  errors.injectionModals?.[modalIndex]?.[
                                    rowIndex
                                  ]?.endDate
                                }
                                errorMessage={
                                  errors.injectionModals?.[modalIndex]?.[
                                    rowIndex
                                  ]?.endDate
                                }
                              />
                              <TimeInput
                                type="startTime"
                                heading="Start Time"
                                value={row.startTime}
                                minTime={minTimeForStartTime(row)}
                                maxTime={endTimeDisplay}
                                disabled={row.rtcChecked}
                                rtcButton={true}
                                onChange={(value) =>
                                  handleInjectionChange(
                                    modalIndex,
                                    rowIndex,
                                    "startTime",
                                    value,
                                  )
                                }
                                rtcChecked={row.rtcChecked}
                                handleRTC={(value) => {
                                  const isRTC = value === "24:00";
                                  const startDateObj = new Date(row.startDate);
                                  const today = new Date();
                                  today.setHours(0, 0, 0, 0);
                                  startDateObj.setHours(0, 0, 0, 0);

                                  if (
                                    isRTC &&
                                    startDateObj.getTime() === today.getTime()
                                  ) {
                                    const startDT = new Date(
                                      `${row.startDate}T${row.startTime}`,
                                    );
                                    const threeHoursLater = new Date(
                                      new Date().getTime() + 3 * 60 * 60 * 1000,
                                    );
                                    if (startDT && startDT < threeHoursLater) {
                                      toast.error(
                                        "The start time must be at least three hours later than the current time",
                                      );
                                      return;
                                    }
                                  }

                                  handleInjectionChange(
                                    modalIndex,
                                    rowIndex,
                                    "endTime",
                                    transformTimeForBackend(value),
                                  );
                                  handleInjectionChange(
                                    modalIndex,
                                    rowIndex,
                                    "rtcChecked",
                                    isRTC,
                                  );
                                  if (isRTC) {
                                    handleInjectionChange(
                                      modalIndex,
                                      rowIndex,
                                      "startTime",
                                      "00:00",
                                    );
                                  } else {
                                    handleInjectionChange(
                                      modalIndex,
                                      rowIndex,
                                      "startTime",
                                      "",
                                    );
                                  }
                                }}
                                height={35}
                                error={
                                  errors.injectionModals?.[modalIndex]?.[
                                    rowIndex
                                  ]?.startTime
                                }
                                errorMessage={
                                  errors.injectionModals?.[modalIndex]?.[
                                    rowIndex
                                  ]?.startTime
                                }
                              />
                              <TimeInput
                                type="endTime"
                                heading="End Time"
                                minTime={row.startTime}
                                maxTime="24:00"
                                minutesStep={15}
                                value={endTimeDisplay}
                                height={35}
                                onChange={(value) =>
                                  handleInjectionChange(
                                    modalIndex,
                                    rowIndex,
                                    "endTime",
                                    transformTimeForBackend(value),
                                  )
                                }
                                rtcChecked={row.rtcChecked}
                                disabled={row.rtcChecked}
                                handleRTC={(value) =>
                                  handleInjectionChange(
                                    modalIndex,
                                    rowIndex,
                                    "endTime",
                                    transformTimeForBackend(value),
                                  )
                                }
                                error={
                                  errors.injectionModals?.[modalIndex]?.[
                                    rowIndex
                                  ]?.endTime
                                }
                                errorMessage={
                                  errors.injectionModals?.[modalIndex]?.[
                                    rowIndex
                                  ]?.endTime
                                }
                              />
                              <TextInput
                                heading="Quantity (MW)"
                                value={row.quantity}
                                example={"e.g. 100"}
                                height={35}
                                disabled={
                                  !(
                                    row.startDate &&
                                    row.endDate &&
                                    row.startTime &&
                                    row.endTime
                                  )
                                }
                                onChange={(val) => {
                                  if (/^(\d+(\.\d{0,2})?)?$/.test(val)) {
                                    handleInjectionChange(
                                      modalIndex,
                                      rowIndex,
                                      "quantity",
                                      val,
                                    );
                                  }
                                }}
                                error={
                                  errors.injectionModals?.[modalIndex]?.[
                                    rowIndex
                                  ]?.quantity
                                }
                              />
                              <TextInput
                                heading="Units (MWh) *"
                                value={(() => {
                                  try {
                                    const days =
                                      row.startDate && row.endDate
                                        ? (new Date(row.endDate) -
                                            new Date(row.startDate)) /
                                            (1000 * 60 * 60 * 24) +
                                          1
                                        : 0;
                                    const totalHrs =
                                      calculateTotalHours(
                                        row.startTime,
                                        row.endTime === "23:59"
                                          ? "24:00"
                                          : row.endTime,
                                      ) || 0;
                                    const quantity =
                                      parseFloat(row.quantity) || 0;
                                    const units = days * totalHrs * quantity;

                                    // Ensure units is a valid number before calling toFixed
                                    if (isNaN(units) || !isFinite(units)) {
                                      return "0.00";
                                    }

                                    return units > 0
                                      ? Number(units).toFixed(2)
                                      : "0.00";
                                  } catch (e) {
                                    console.error(
                                      "Error calculating units:",
                                      e,
                                    );
                                    return "0.00";
                                  }
                                })()}
                                example={"e.g. 100"}
                                disabled={true}
                                height={35}
                              />
                              <div
                                className={`display_flex_column_gap_4 ${Styles.alterContainer}`}
                              >
                                {rowArr.length > 1 ||
                                injectionModals.length > 1 ? (
                                  <div
                                    onClick={() =>
                                      removeInjectionModal(modalIndex)
                                    }
                                    style={{ cursor: "pointer" }}
                                  >
                                    <DeleteIcon style={{ fontSize: 16 }} />
                                  </div>
                                ) : null}
                                <div
                                  onClick={addInjectionModal}
                                  style={{ cursor: "pointer" }}
                                >
                                  <AddIcon style={{ fontSize: 16 }} />
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  );
                })}

                <div className={`display_flex_column_gap_4`}>
                  <div
                    className={`display_flex_row_common ${Styles.eachSelectionMainContainer}`}
                  >
                    <TextInput
                      heading="Banking Factor (%)"
                      value={bankingFactor}
                      example={"e.g. 105"}
                      type="number"
                      onChange={(val) => {
                        if (/^(\d+(\.\d{0,2})?)?$/.test(val)) {
                          handleBankingFactorChange(val);
                        }
                      }}
                      height={35}
                      error={errors.bankingFactor}
                    />
                    <TextInput
                      heading="Settlement Rate (₹/kWh)*"
                      value={settlementRate}
                      example={"DAM+2 or DAM-2"}
                      onChange={handleSettlementRateChange}
                      height={35}
                      error={errors.settlementRate}
                      additionalElement={
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "4px",
                            marginTop: "4px",
                          }}
                        >
                          <span style={{ fontSize: "12px", color: "#666" }}>
                            Sign:
                          </span>
                          <button
                            type="button"
                            onClick={() => handleSettlementRateSignChange("+")}
                            style={{
                              padding: "2px 6px",
                              fontSize: "12px",
                              border: "1px solid #ccc",
                              backgroundColor: settlementRate.includes("DAM+")
                                ? "#007bff"
                                : "#fff",
                              color: settlementRate.includes("DAM+")
                                ? "#fff"
                                : "#000",
                              cursor: "pointer",
                              borderRadius: "3px",
                            }}
                          >
                            +
                          </button>
                          <button
                            type="button"
                            onClick={() => handleSettlementRateSignChange("-")}
                            style={{
                              padding: "2px 6px",
                              fontSize: "12px",
                              border: "1px solid #ccc",
                              backgroundColor: settlementRate.includes("DAM-")
                                ? "#007bff"
                                : "#fff",
                              color: settlementRate.includes("DAM-")
                                ? "#fff"
                                : "#000",
                              cursor: "pointer",
                              borderRadius: "3px",
                            }}
                          >
                            -
                          </button>
                        </div>
                      }
                    />

                    <div className={Styles.bankingTypeContainer}>
                      <div className={Styles.typeHead}>Type</div>
                      <div className={Styles.bankTypeSub}>
                        {["GNA", "TGNA", "EITHER"].map((type) => (
                          <div
                            key={type}
                            className={`${Styles.firstType} ${
                              activeType === type ||
                              (activeType === "TGNA" && type === "TGNA") ||
                              (activeType === "T-GNA" && type === "TGNA") ||
                              (activeType === "Either" && type === "EITHER")
                                ? Styles.active
                                : ""
                            }`}
                            onClick={() => handleClick(type)}
                          >
                            {type}
                          </div>
                        ))}
                      </div>
                    </div>

                    <div>
                      <div className={Styles.uploadCont}>
                        Upload T&C
                        <span>
                          {fileValue?.id && (
                            <span
                              onClick={() => handleViewFile(fileValue.id)}
                              style={{ cursor: "pointer" }}
                              title="View file"
                            >
                              <ViewIcon
                                style={{
                                  width: "20px",
                                  height: "20px",
                                  paddingLeft: "15%",
                                }}
                              />
                            </span>
                          )}
                        </span>
                      </div>
                      <div className={Styles.customFileUpload}>
                        <label
                          htmlFor="ledgerFileUpload"
                          className={Styles.uploadLabel}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            paddingLeft: "15px",
                            gap: "8px",
                          }}
                        >
                          {fileValue?.fileName ? (
                            <div
                              style={{
                                width: "90%",
                                height: "36px",
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                              }}
                              className={`display_flex_row`}
                            >
                              <span className={Styles.uploadedFileName}>
                                <strong>{fileValue.fileName}</strong>
                              </span>

                              <span
                                onClick={(e) => {
                                  e.preventDefault();
                                  handleRemoveTCFile();
                                }}
                                style={{ cursor: "pointer" }}
                                title="Remove file"
                              >
                                <CrossIcon
                                  style={{
                                    fontSize: 16,
                                    color: "red",
                                    width: "13px",
                                    height: "13px",
                                  }}
                                />
                              </span>
                            </div>
                          ) : tcFileName ? (
                            <>
                              <span className={Styles.uploadedFileName}>
                                Selected: <strong>{tcFileName}</strong>
                              </span>
                              <span
                                onClick={(e) => {
                                  e.preventDefault();
                                  handleRemoveTCFile();
                                }}
                                style={{ cursor: "pointer" }}
                                title="Remove selected file"
                              >
                                <CrossIcon
                                  style={{ fontSize: 16, color: "red" }}
                                />
                              </span>
                            </>
                          ) : (
                            <div className={Styles.uploadHeader}>
                              <span>
                                <Upload
                                  width="24px"
                                  height="24px"
                                  display="flex"
                                  paddingBottom="2px"
                                  justifyContent="right"
                                />
                              </span>
                              <div>
                                {" "}
                                Upload T&C File
                                {docId && (
                                  <span
                                    onClick={() => handleViewFile(docId)}
                                    style={{ cursor: "pointer" }}
                                    title="View file"
                                  >
                                    <ViewIcon
                                      style={{
                                        width: "20px",
                                        height: "20px",
                                        paddingTop: "2px",
                                      }}
                                    />
                                  </span>
                                )}
                              </div>
                            </div>
                          )}
                        </label>
                        <input
                          type="file"
                          id="ledgerFileUpload"
                          accept=".pdf"
                          onChange={(e) =>
                            handleFileChange(e.target.files[0], e)
                          }
                          style={{ display: "none" }}
                        />
                        {fileValue?.error && (
                          <div
                            style={{
                              color: "red",
                              marginTop: "4px",
                              fontSize: "10px",
                            }}
                          >
                            {fileValue.error}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                {drawalModals.map((rowArr, modalIndex) => {
                  const maxInjection = getMaxInjectionQuantity();
                  const factor = Number(bankingFactor) || 0;
                  let totalInjection = 0;
                  injectionModals.forEach((modal) => {
                    modal.forEach((slot) => {
                      const qty = Number(slot.quantity) || 0;
                      totalInjection += qty;
                    });
                  });

                  const requiredReturn = totalInjection * factor;
                  let totalDrawal = 0;
                  drawalModals.forEach((modal) => {
                    modal.forEach((slot) => {
                      const qty = Number(slot.quantity) || 0;
                      totalDrawal += qty;
                    });
                  });

                  const remaining = requiredReturn - totalDrawal;
                  const shouldShow = factor > 0 && totalInjection > 0;

                  return (
                    <div
                      key={modalIndex}
                      className={`display_flex_column_gap_4 ${Styles.injectDrawalCont}`}
                      style={{ position: "relative" }}
                    >
                      <div className={Styles.draInHeader}>
                        Drawal/Return{" "}
                        {drawalModals.length > 1
                          ? ` ${modalIndex + 1}`
                          : ""}{" "}
                      </div>

                      <div className={Styles.rowsScrollableContainer}>
                        {rowArr.map((row, rowIndex) => {
                          const endTimeDisplay = transformTimeForDisplay(
                            row.endTime,
                          );
                          return (
                            <div
                              key={`${modalIndex}-${rowIndex}`}
                              className={`display_flex_row_common ${Styles.eachSelectionMainContainer}`}
                            >
                              <DateInput
                                heading="Start Date"
                                value={row.startDate}
                                minDate={today}
                                height={35}
                                maxDate={
                                  row.endDate
                                    ? new Date(row.endDate)
                                    : undefined
                                }
                                onChange={(date) =>
                                  handleDrawalChange(
                                    modalIndex,
                                    rowIndex,
                                    "startDate",
                                    date,
                                  )
                                }
                                error={
                                  errors.drawalModals?.[modalIndex]?.[rowIndex]
                                    ?.startDate
                                }
                                errorMessage={
                                  errors.drawalModals?.[modalIndex]?.[rowIndex]
                                    ?.startDate
                                }
                              />
                              <DateInput
                                heading="End Date"
                                value={row.endDate}
                                height={35}
                                minDate={
                                  row.startDate
                                    ? new Date(row.startDate)
                                    : today
                                }
                                onChange={(date) =>
                                  handleDrawalChange(
                                    modalIndex,
                                    rowIndex,
                                    "endDate",
                                    date,
                                  )
                                }
                                error={
                                  errors.drawalModals?.[modalIndex]?.[rowIndex]
                                    ?.endDate
                                }
                                errorMessage={
                                  errors.drawalModals?.[modalIndex]?.[rowIndex]
                                    ?.endDate
                                }
                              />
                              <TimeInput
                                type="startTime"
                                heading="Start Time"
                                value={row.startTime}
                                height={35}
                                rtcButton={true}
                                minTime={minTimeForStartTime(row)}
                                maxTime={endTimeDisplay}
                                disabled={row.rtcChecked}
                                onChange={(value) =>
                                  handleDrawalChange(
                                    modalIndex,
                                    rowIndex,
                                    "startTime",
                                    value,
                                  )
                                }
                                rtcChecked={row.rtcChecked}
                                handleRTC={(value) => {
                                  const isRTC = value === "24:00";
                                  handleDrawalChange(
                                    modalIndex,
                                    rowIndex,
                                    "endTime",
                                    transformTimeForBackend(value),
                                  );
                                  handleDrawalChange(
                                    modalIndex,
                                    rowIndex,
                                    "rtcChecked",
                                    isRTC,
                                  );
                                  if (isRTC) {
                                    handleDrawalChange(
                                      modalIndex,
                                      rowIndex,
                                      "startTime",
                                      "00:00",
                                    );
                                  } else {
                                    handleDrawalChange(
                                      modalIndex,
                                      rowIndex,
                                      "startTime",
                                      "",
                                    );
                                  }
                                }}
                                error={
                                  errors.drawalModals?.[modalIndex]?.[rowIndex]
                                    ?.startTime
                                }
                                errorMessage={
                                  errors.drawalModals?.[modalIndex]?.[rowIndex]
                                    ?.startTime
                                }
                              />
                              <TimeInput
                                type="endTime"
                                heading="End Time"
                                value={endTimeDisplay}
                                minTime={row.startTime}
                                maxTime="24:00"
                                minutesStep={15}
                                height={35}
                                disabled={row.rtcChecked}
                                onChange={(value) =>
                                  handleDrawalChange(
                                    modalIndex,
                                    rowIndex,
                                    "endTime",
                                    transformTimeForBackend(value),
                                  )
                                }
                                rtcChecked={row.rtcChecked}
                                handleRTC={(value) =>
                                  handleDrawalChange(
                                    modalIndex,
                                    rowIndex,
                                    "endTime",
                                    transformTimeForBackend(value),
                                  )
                                }
                                error={
                                  errors.drawalModals?.[modalIndex]?.[rowIndex]
                                    ?.endTime
                                }
                                errorMessage={
                                  errors.drawalModals?.[modalIndex]?.[rowIndex]
                                    ?.endTime
                                }
                              />
                              <TextInput
                                heading="Quantity (MW)"
                                value={row.quantity}
                                example={"e.g. 100"}
                                height={35}
                                disabled={
                                  !(
                                    row.startDate &&
                                    row.endDate &&
                                    row.startTime &&
                                    row.endTime
                                  )
                                }
                                onChange={(val) => {
                                  if (/^(\d+(\.\d{0,2})?)?$/.test(val)) {
                                    handleDrawalChange(
                                      modalIndex,
                                      rowIndex,
                                      "quantity",
                                      val,
                                    );
                                  }
                                }}
                                error={
                                  errors.drawalModals?.[modalIndex]?.[rowIndex]
                                    ?.quantity
                                }
                              />
                              <TextInput
                                heading="Units (MWh) *"
                                value={(() => {
                                  try {
                                    const days =
                                      row.startDate && row.endDate
                                        ? (new Date(row.endDate) -
                                            new Date(row.startDate)) /
                                            (1000 * 60 * 60 * 24) +
                                          1
                                        : 0;
                                    const totalHrs =
                                      calculateTotalHours(
                                        row.startTime,
                                        row.endTime === "23:59"
                                          ? "24:00"
                                          : row.endTime,
                                      ) || 0;
                                    const quantity =
                                      parseFloat(row.quantity) || 0;
                                    const units = days * totalHrs * quantity;

                                    if (isNaN(units) || !isFinite(units)) {
                                      return "0.00";
                                    }

                                    return units > 0
                                      ? Number(units).toFixed(2)
                                      : "0.00";
                                  } catch (e) {
                                    return "0.00";
                                  }
                                })()}
                                example={"e.g. 100"}
                                disabled={true}
                                height={35}
                              />
                              <div
                                className={`display_flex_column_gap_4 ${Styles.alterContainer}`}
                              >
                                {rowArr.length > 1 ||
                                drawalModals.length > 1 ? (
                                  <div
                                    onClick={() =>
                                      removeDrawalModal(modalIndex)
                                    }
                                    style={{ cursor: "pointer" }}
                                  >
                                    <DeleteIcon style={{ fontSize: 16 }} />
                                  </div>
                                ) : null}
                                <div
                                  onClick={addDrawalModal}
                                  style={{ cursor: "pointer" }}
                                >
                                  <AddIcon style={{ fontSize: 16 }} />
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  );
                })}
              </>
            ) : (
              <>
                {drawalModals.map((rowArr, modalIndex) => {
                  const row = rowArr[0] || {};
                  const endTimeDisplay = transformTimeForDisplay(row.endTime);
                  const maxInjection = getMaxInjectionQuantity();
                  const factor = Number(bankingFactor) || 0;
                  let totalInjection = 0;
                  injectionModals.forEach((modal) => {
                    modal.forEach((slot) => {
                      const qty = Number(slot.quantity) || 0;
                      totalInjection += qty;
                    });
                  });

                  const requiredReturn = totalInjection * factor;
                  let totalDrawal = 0;
                  drawalModals.forEach((modal) => {
                    modal.forEach((slot) => {
                      const qty = Number(slot.quantity) || 0;
                      totalDrawal += qty;
                    });
                  });

                  const remaining = requiredReturn - totalDrawal;
                  const shouldShow = factor > 0 && totalInjection > 0;

                  return (
                    <div
                      key={modalIndex}
                      className={`display_flex_column_gap_4 ${Styles.injectDrawalCont}`}
                      style={{ position: "relative" }}
                    >
                      <div className={Styles.draInHeader}>
                        Drawal{" "}
                        {drawalModals.length > 1 ? ` ${modalIndex + 1}` : ""}
                      </div>
                      <div className={Styles.rowsScrollableContainer}>
                        {rowArr.map((row, rowIndex) => {
                          const endTimeDisplay = transformTimeForDisplay(
                            row.endTime,
                          );
                          return (
                            <div
                              key={`${modalIndex}-${rowIndex}`}
                              className={`display_flex_row_common ${Styles.eachSelectionMainContainer}`}
                            >
                              <DateInput
                                heading="Start Date"
                                value={row.startDate}
                                minDate={today}
                                height={35}
                                maxDate={
                                  row.endDate
                                    ? new Date(row.endDate)
                                    : undefined
                                }
                                onChange={(date) =>
                                  handleDrawalChange(
                                    modalIndex,
                                    rowIndex,
                                    "startDate",
                                    date,
                                  )
                                }
                                error={
                                  errors.drawalModals?.[modalIndex]?.[rowIndex]
                                    ?.startDate
                                }
                                errorMessage={
                                  errors.drawalModals?.[modalIndex]?.[rowIndex]
                                    ?.startDate
                                }
                              />
                              <DateInput
                                heading="End Date"
                                value={row.endDate}
                                height={35}
                                minDate={
                                  row.startDate
                                    ? new Date(row.startDate)
                                    : today
                                }
                                onChange={(date) =>
                                  handleDrawalChange(
                                    modalIndex,
                                    rowIndex,
                                    "endDate",
                                    date,
                                  )
                                }
                                error={
                                  errors.drawalModals?.[modalIndex]?.[rowIndex]
                                    ?.endDate
                                }
                                errorMessage={
                                  errors.drawalModals?.[modalIndex]?.[rowIndex]
                                    ?.endDate
                                }
                              />
                              <TimeInput
                                type="startTime"
                                heading="Start Time"
                                value={row.startTime}
                                height={35}
                                rtcButton={true}
                                minTime={minTimeForStartTime(row)}
                                maxTime={endTimeDisplay}
                                disabled={row.rtcChecked}
                                onChange={(value) =>
                                  handleDrawalChange(
                                    modalIndex,
                                    rowIndex,
                                    "startTime",
                                    value,
                                  )
                                }
                                rtcChecked={row.rtcChecked}
                                handleRTC={(value) => {
                                  const isRTC = value === "24:00";
                                  handleDrawalChange(
                                    modalIndex,
                                    rowIndex,
                                    "endTime",
                                    transformTimeForBackend(value),
                                  );
                                  handleDrawalChange(
                                    modalIndex,
                                    rowIndex,
                                    "rtcChecked",
                                    isRTC,
                                  );
                                  if (isRTC) {
                                    handleDrawalChange(
                                      modalIndex,
                                      rowIndex,
                                      "startTime",
                                      "00:00",
                                    );
                                  } else {
                                    handleDrawalChange(
                                      modalIndex,
                                      rowIndex,
                                      "startTime",
                                      "",
                                    );
                                  }
                                }}
                                error={
                                  errors.drawalModals?.[modalIndex]?.[rowIndex]
                                    ?.startTime
                                }
                                errorMessage={
                                  errors.drawalModals?.[modalIndex]?.[rowIndex]
                                    ?.startTime
                                }
                              />
                              <TimeInput
                                type="endTime"
                                heading="End Time"
                                value={endTimeDisplay}
                                minTime={row.startTime}
                                maxTime="24:00"
                                minutesStep={15}
                                height={35}
                                disabled={row.rtcChecked}
                                onChange={(value) =>
                                  handleDrawalChange(
                                    modalIndex,
                                    rowIndex,
                                    "endTime",
                                    transformTimeForBackend(value),
                                  )
                                }
                                rtcChecked={row.rtcChecked}
                                handleRTC={(value) =>
                                  handleDrawalChange(
                                    modalIndex,
                                    rowIndex,
                                    "endTime",
                                    transformTimeForBackend(value),
                                  )
                                }
                                error={
                                  errors.drawalModals?.[modalIndex]?.[rowIndex]
                                    ?.endTime
                                }
                                errorMessage={
                                  errors.drawalModals?.[modalIndex]?.[rowIndex]
                                    ?.endTime
                                }
                              />
                              <TextInput
                                heading="Quantity (MW)"
                                value={row.quantity}
                                example={"e.g. 100"}
                                height={35}
                                onChange={(val) => {
                                  if (/^(\d+(\.\d{0,2})?)?$/.test(val)) {
                                    handleDrawalChange(
                                      modalIndex,
                                      rowIndex,
                                      "quantity",
                                      val,
                                    );
                                  }
                                }}
                                error={
                                  errors.drawalModals?.[modalIndex]?.[rowIndex]
                                    ?.quantity
                                }
                              />
                              <TextInput
                                heading="Units (MWh) *"
                                value={(() => {
                                  try {
                                    const days =
                                      row.startDate && row.endDate
                                        ? (new Date(row.endDate) -
                                            new Date(row.startDate)) /
                                            (1000 * 60 * 60 * 24) +
                                          1
                                        : 0;
                                    const totalHrs =
                                      calculateTotalHours(
                                        row.startTime,
                                        row.endTime === "23:59"
                                          ? "24:00"
                                          : row.endTime,
                                      ) || 0;
                                    const quantity =
                                      parseFloat(row.quantity) || 0;
                                    const units = days * totalHrs * quantity;

                                    if (isNaN(units) || !isFinite(units)) {
                                      return "0.00";
                                    }

                                    return units > 0
                                      ? Number(units).toFixed(2)
                                      : "0.00";
                                  } catch (e) {
                                    return "0.00";
                                  }
                                })()}
                                example={"e.g. 100"}
                                disabled={true}
                                height={35}
                              />
                              <div
                                className={`display_flex_column_gap_4 ${Styles.alterContainer}`}
                              >
                                {rowArr.length > 1 ||
                                drawalModals.length > 1 ? (
                                  <div
                                    onClick={() =>
                                      removeDrawalModal(modalIndex)
                                    }
                                    style={{ cursor: "pointer" }}
                                  >
                                    <DeleteIcon style={{ fontSize: 16 }} />
                                  </div>
                                ) : null}
                                <div
                                  onClick={addDrawalModal}
                                  style={{ cursor: "pointer" }}
                                >
                                  <AddIcon style={{ fontSize: 16 }} />
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  );
                })}

                <div className={`display_flex_column_gap_4`}>
                  <div
                    className={`display_flex_row_common ${Styles.eachSelectionMainContainer}`}
                  >
                    <TextInput
                      heading="Banking Factor (%)"
                      value={bankingFactor}
                      example={"e.g. 105"}
                      type="number"
                      onChange={(val) => {
                        if (/^(\d+(\.\d{0,2})?)?$/.test(val)) {
                          handleBankingFactorChange(val);
                        }
                      }}
                      height={35}
                      error={errors.bankingFactor}
                    />
                    <TextInput
                      heading="Settlement Rate (₹/kWh)*"
                      value={settlementRate}
                      example={"DAM+2 or DAM-2"}
                      onChange={handleSettlementRateChange}
                      height={35}
                      error={errors.settlementRate}
                      additionalElement={
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "4px",
                            marginTop: "4px",
                          }}
                        >
                          <span style={{ fontSize: "12px", color: "#666" }}>
                            Sign:
                          </span>
                          <button
                            type="button"
                            onClick={() => handleSettlementRateSignChange("+")}
                            style={{
                              padding: "2px 6px",
                              fontSize: "12px",
                              border: "1px solid #ccc",
                              backgroundColor: settlementRate.includes("DAM+")
                                ? "#007bff"
                                : "#fff",
                              color: settlementRate.includes("DAM+")
                                ? "#fff"
                                : "#000",
                              cursor: "pointer",
                              borderRadius: "3px",
                            }}
                          >
                            +
                          </button>
                          <button
                            type="button"
                            onClick={() => handleSettlementRateSignChange("-")}
                            style={{
                              padding: "2px 6px",
                              fontSize: "12px",
                              border: "1px solid #ccc",
                              backgroundColor: settlementRate.includes("DAM-")
                                ? "#007bff"
                                : "#fff",
                              color: settlementRate.includes("DAM-")
                                ? "#fff"
                                : "#000",
                              cursor: "pointer",
                              borderRadius: "3px",
                            }}
                          >
                            -
                          </button>
                        </div>
                      }
                    />

                    <div className={Styles.bankingTypeContainer}>
                      <div className={Styles.typeHead}>Type</div>
                      <div className={Styles.bankTypeSub}>
                        {["GNA", "TGNA", "EITHER"].map((type) => (
                          <div
                            key={type}
                            className={`${Styles.firstType} ${
                              activeType === type ||
                              (activeType === "TGNA" && type === "TGNA") ||
                              (activeType === "T-GNA" && type === "TGNA") ||
                              (activeType === "Either" && type === "EITHER")
                                ? Styles.active
                                : ""
                            }`}
                            onClick={() => handleClick(type)}
                          >
                            {type}
                          </div>
                        ))}
                      </div>
                    </div>

                    <div>
                      <div className={Styles.uploadCont}>
                        Upload T&C
                        <span>
                          {fileValue?.id && (
                            <span
                              onClick={() => handleViewFile(fileValue.id)}
                              style={{ cursor: "pointer" }}
                              title="View file"
                            >
                              <ViewIcon
                                style={{
                                  width: "20px",
                                  height: "20px",
                                  paddingLeft: "15%",
                                }}
                              />
                            </span>
                          )}
                        </span>
                      </div>
                      <div className={Styles.customFileUpload}>
                        <label
                          htmlFor="ledgerFileUpload"
                          className={Styles.uploadLabel}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            paddingLeft: "15px",
                            gap: "8px",
                          }}
                        >
                          {fileValue?.fileName ? (
                            <div
                              style={{
                                width: "90%",
                                height: "36px",
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                              }}
                              className={`display_flex_row`}
                            >
                              <span className={Styles.uploadedFileName}>
                                <strong>{fileValue.fileName}</strong>
                              </span>

                              <span
                                onClick={(e) => {
                                  e.preventDefault();
                                  handleRemoveTCFile();
                                }}
                                style={{ cursor: "pointer" }}
                                title="Remove file"
                              >
                                <CrossIcon
                                  style={{
                                    fontSize: 16,
                                    color: "red",
                                    width: "13px",
                                    height: "13px",
                                  }}
                                />
                              </span>
                            </div>
                          ) : tcFileName ? (
                            <>
                              <span className={Styles.uploadedFileName}>
                                Selected: <strong>{tcFileName}</strong>
                              </span>
                              <span
                                onClick={(e) => {
                                  e.preventDefault();
                                  handleRemoveTCFile();
                                }}
                                style={{ cursor: "pointer" }}
                                title="Remove selected file"
                              >
                                <CrossIcon
                                  style={{ fontSize: 16, color: "red" }}
                                />
                              </span>
                            </>
                          ) : (
                            <div className={Styles.uploadHeader}>
                              <span>
                                <Upload
                                  width="24px"
                                  height="24px"
                                  display="flex"
                                  paddingBottom="2px"
                                  justifyContent="right"
                                />
                              </span>
                              <div>
                                {" "}
                                Upload T&C File
                                {docId && (
                                  <span
                                    onClick={() => handleViewFile(docId)}
                                    style={{ cursor: "pointer" }}
                                    title="View file"
                                  >
                                    <ViewIcon
                                      style={{
                                        width: "20px",
                                        height: "20px",
                                        paddingTop: "2px",
                                      }}
                                    />
                                  </span>
                                )}
                              </div>
                            </div>
                          )}
                        </label>
                        <input
                          type="file"
                          id="ledgerFileUpload"
                          accept=".pdf"
                          onChange={(e) =>
                            handleFileChange(e.target.files[0], e)
                          }
                          style={{ display: "none" }}
                        />
                        {fileValue?.error && (
                          <div
                            style={{
                              color: "red",
                              marginTop: "4px",
                              fontSize: "10px",
                            }}
                          >
                            {fileValue.error}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                {injectionModals.map((rowArr, modalIndex) => {
                  return (
                    <div
                      key={modalIndex}
                      className={`display_flex_column_gap_4 ${Styles.injectDrawalCont}`}
                      style={{ position: "relative" }}
                    >
                      <div className={Styles.draInHeader}>
                        Injection/Return{" "}
                        {injectionModals.length > 1 ? ` ${modalIndex + 1}` : ""}
                      </div>
                      <div className={Styles.draInHeader}>
                        Injection/Return{" "}
                        {injectionModals.length > 1 ? ` ${modalIndex + 1}` : ""}
                      </div>
                      <div className={Styles.rowsScrollableContainer}>
                        {rowArr.map((row, rowIndex) => {
                          const endTimeDisplay = transformTimeForDisplay(
                            row.endTime,
                          );
                          return (
                            <div
                              key={`${modalIndex}-${rowIndex}`}
                              className={`display_flex_row_common ${Styles.eachSelectionMainContainer}`}
                            >
                              <DateInput
                                heading="Start Date"
                                value={row.startDate}
                                minDate={today}
                                height={35}
                                maxDate={
                                  row.endDate
                                    ? new Date(row.endDate)
                                    : undefined
                                }
                                onChange={(date) =>
                                  handleInjectionChange(
                                    modalIndex,
                                    rowIndex,
                                    "startDate",
                                    date,
                                  )
                                }
                                error={
                                  errors.injectionModals?.[modalIndex]?.[
                                    rowIndex
                                  ]?.startDate
                                }
                                errorMessage={
                                  errors.injectionModals?.[modalIndex]?.[
                                    rowIndex
                                  ]?.startDate
                                }
                              />
                              <DateInput
                                heading="End Date"
                                value={row.endDate}
                                height={35}
                                minDate={
                                  row.startDate
                                    ? new Date(row.startDate)
                                    : today
                                }
                                onChange={(date) =>
                                  handleInjectionChange(
                                    modalIndex,
                                    rowIndex,
                                    "endDate",
                                    date,
                                  )
                                }
                                error={
                                  errors.injectionModals?.[modalIndex]?.[
                                    rowIndex
                                  ]?.endDate
                                }
                                errorMessage={
                                  errors.injectionModals?.[modalIndex]?.[
                                    rowIndex
                                  ]?.endDate
                                }
                              />
                              <TimeInput
                                type="startTime"
                                heading="Start Time"
                                value={row.startTime}
                                height={35}
                                rtcButton={true}
                                minTime={minTimeForStartTime(row)}
                                maxTime={endTimeDisplay}
                                disabled={row.rtcChecked}
                                onChange={(value) =>
                                  handleInjectionChange(
                                    modalIndex,
                                    rowIndex,
                                    "startTime",
                                    value,
                                  )
                                }
                                rtcChecked={row.rtcChecked}
                                handleRTC={(value) => {
                                  const isRTC = value === "24:00";
                                  const startDateObj = new Date(row.startDate);
                                  const today = new Date();
                                  today.setHours(0, 0, 0, 0);
                                  startDateObj.setHours(0, 0, 0, 0);

                                  if (
                                    isRTC &&
                                    startDateObj.getTime() === today.getTime()
                                  ) {
                                    const startDT = new Date(
                                      `${row.startDate}T${row.startTime}`,
                                    );
                                    const threeHoursLater = new Date(
                                      new Date().getTime() + 3 * 60 * 60 * 1000,
                                    );
                                    if (startDT && startDT < threeHoursLater) {
                                      toast.error(
                                        "The start time must be at least three hours later than the current time",
                                      );
                                      return;
                                    }
                                  }

                                  handleInjectionChange(
                                    modalIndex,
                                    rowIndex,
                                    "endTime",
                                    transformTimeForBackend(value),
                                  );
                                  handleInjectionChange(
                                    modalIndex,
                                    rowIndex,
                                    "rtcChecked",
                                    isRTC,
                                  );
                                  if (isRTC)
                                    handleInjectionChange(
                                      modalIndex,
                                      rowIndex,
                                      "startTime",
                                      "00:00",
                                    );
                                  else
                                    handleInjectionChange(
                                      modalIndex,
                                      rowIndex,
                                      "startTime",
                                      "",
                                    );
                                }}
                                // height={35}
                                error={
                                  errors.injectionModals?.[modalIndex]?.[
                                    rowIndex
                                  ]?.startTime
                                }
                                errorMessage={
                                  errors.injectionModals?.[modalIndex]?.[
                                    rowIndex
                                  ]?.startTime
                                }
                              />
                              <TimeInput
                                type="endTime"
                                heading="End Time"
                                minTime={row.startTime}
                                maxTime="24:00"
                                minutesStep={15}
                                value={endTimeDisplay}
                                height={35}
                                onChange={(value) =>
                                  handleInjectionChange(
                                    modalIndex,
                                    rowIndex,
                                    "endTime",
                                    transformTimeForBackend(value),
                                  )
                                }
                                rtcChecked={row.rtcChecked}
                                disabled={row.rtcChecked}
                                handleRTC={(value) =>
                                  handleInjectionChange(
                                    modalIndex,
                                    rowIndex,
                                    "endTime",
                                    transformTimeForBackend(value),
                                  )
                                }
                                error={
                                  errors.injectionModals?.[modalIndex]?.[
                                    rowIndex
                                  ]?.endTime
                                }
                                errorMessage={
                                  errors.injectionModals?.[modalIndex]?.[
                                    rowIndex
                                  ]?.endTime
                                }
                              />
                              <TextInput
                                heading="Quantity (MW)"
                                value={row.quantity}
                                example={"e.g. 100"}
                                height={35}
                                disabled={
                                  !(
                                    row.startDate &&
                                    row.endDate &&
                                    row.startTime &&
                                    row.endTime
                                  )
                                }
                                onChange={(val) => {
                                  if (/^(\d+(\.\d{0,2})?)?$/.test(val)) {
                                    handleInjectionChange(
                                      modalIndex,
                                      rowIndex,
                                      "quantity",
                                      val,
                                    );
                                  }
                                }}
                                error={
                                  errors.injectionModals?.[modalIndex]?.[
                                    rowIndex
                                  ]?.quantity
                                }
                              />
                              <TextInput
                                heading="Units (MWh) *"
                                value={(() => {
                                  try {
                                    const days =
                                      row.startDate && row.endDate
                                        ? (new Date(row.endDate) -
                                            new Date(row.startDate)) /
                                            (1000 * 60 * 60 * 24) +
                                          1
                                        : 0;
                                    const totalHrs =
                                      calculateTotalHours(
                                        row.startTime,
                                        row.endTime === "23:59"
                                          ? "24:00"
                                          : row.endTime,
                                      ) || 0;
                                    const quantity =
                                      parseFloat(row.quantity) || 0;
                                    const units = days * totalHrs * quantity;

                                    if (isNaN(units) || !isFinite(units)) {
                                      return "0.00";
                                    }

                                    return units > 0
                                      ? Number(units).toFixed(2)
                                      : "0.00";
                                  } catch (e) {
                                    return "0.00";
                                  }
                                })()}
                                example={"e.g. 100"}
                                disabled={true}
                                height={35}
                              />
                              <div
                                className={`display_flex_column_gap_4 ${Styles.alterContainer}`}
                              >
                                {rowArr.length > 1 ||
                                injectionModals.length > 1 ? (
                                  <div
                                    onClick={() =>
                                      removeInjectionModal(modalIndex)
                                    }
                                    style={{ cursor: "pointer" }}
                                  >
                                    <DeleteIcon style={{ fontSize: 16 }} />
                                  </div>
                                ) : null}
                                <div
                                  onClick={addInjectionModal}
                                  style={{ cursor: "pointer" }}
                                >
                                  <AddIcon style={{ fontSize: 16 }} />
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  );
                })}
              </>
            )}

            <FormGroup>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "20px",
                  justifyContent: "space-between",
                }}
              >
                <div className={Styles.injectionBox}>
                  <span className={Styles.headingInjDra}>
                    {isInjectionOnTop ? "Total Injection" : "Total Drawal"}
                  </span>
                  {(() => {
                    if (isInjectionOnTop) {
                      let totalInjectionMwh = 0;

                      injectionModals.forEach((modal) => {
                        modal.forEach((slot) => {
                          const qty = Number(slot.quantity) || 0;
                          const days =
                            slot.startDate && slot.endDate
                              ? (new Date(slot.endDate) -
                                  new Date(slot.startDate)) /
                                  (1000 * 60 * 60 * 24) +
                                1
                              : 0;
                          const totalHrs =
                            calculateTotalHours(
                              slot.startTime,
                              slot.endTime === "23:59" ? "24:00" : slot.endTime,
                            ) || 0;
                          const finalMwh = qty * days * totalHrs;
                          totalInjectionMwh += finalMwh;
                        });
                      });

                      const shouldShow = totalInjectionMwh > 0;

                      return (
                        <span className={Styles.valuesHead}>
                          {totalInjectionMwh.toFixed(2)} MWh
                        </span>
                      );
                    } else {
                      let totalDrawalMwh = 0;

                      drawalModals.forEach((modal) => {
                        modal.forEach((slot) => {
                          const qty = Number(slot.quantity) || 0;
                          const days =
                            slot.startDate && slot.endDate
                              ? (new Date(slot.endDate) -
                                  new Date(slot.startDate)) /
                                  (1000 * 60 * 60 * 24) +
                                1
                              : 0;
                          const totalHrs =
                            calculateTotalHours(
                              slot.startTime,
                              slot.endTime === "23:59" ? "24:00" : slot.endTime,
                            ) || 0;
                          const finalMwh = qty * days * totalHrs;
                          totalDrawalMwh += finalMwh;
                        });
                      });

                      const shouldShow = totalDrawalMwh > 0;

                      return (
                        <span className={Styles.valuesHead}>
                          {totalDrawalMwh.toFixed(2)} MWh
                        </span>
                      );
                    }
                  })()}
                </div>

                <div className={Styles.injectionBox}>
                  <span
                    className={Styles.headingInjDra}
                    style={{ display: "flex", flexDirection: "column" }}
                  >
                    Return Required{" "}
                    <span style={{ fontSize: "10px" }}>
                      (as per Banking Factor)
                    </span>{" "}
                  </span>
                  {(() => {
                    const factor = Number(bankingFactor) || 0;

                    if (isInjectionOnTop) {
                      let totalInjectionMwh = 0;

                      injectionModals.forEach((modal) => {
                        modal.forEach((slot) => {
                          const qty = Number(slot.quantity) || 0;
                          const days =
                            slot.startDate && slot.endDate
                              ? (new Date(slot.endDate) -
                                  new Date(slot.startDate)) /
                                  (1000 * 60 * 60 * 24) +
                                1
                              : 0;
                          const totalHrs =
                            calculateTotalHours(
                              slot.startTime,
                              slot.endTime === "23:59" ? "24:00" : slot.endTime,
                            ) || 0;
                          const finalMwh = qty * days * totalHrs;
                          totalInjectionMwh += finalMwh;
                        });
                      });

                      const requiredReturn = (totalInjectionMwh * factor) / 100;
                      const shouldShow = factor > 0 && totalInjectionMwh > 0;

                      return (
                        <span className={Styles.valuesHead}>
                          {requiredReturn.toFixed(2)} MWh
                        </span>
                      );
                    } else {
                      let totalDrawalMwh = 0;

                      drawalModals.forEach((modal) => {
                        modal.forEach((slot) => {
                          const qty = Number(slot.quantity) || 0;
                          const days =
                            slot.startDate && slot.endDate
                              ? (new Date(slot.endDate) -
                                  new Date(slot.startDate)) /
                                  (1000 * 60 * 60 * 24) +
                                1
                              : 0;
                          const totalHrs =
                            calculateTotalHours(
                              slot.startTime,
                              slot.endTime === "23:59" ? "24:00" : slot.endTime,
                            ) || 0;
                          const finalMwh = qty * days * totalHrs;
                          totalDrawalMwh += finalMwh;
                        });
                      });

                      const requiredReturn =
                        factor > 0 ? totalDrawalMwh * (factor / 100) : 0;
                      const shouldShow = factor > 0 && totalDrawalMwh > 0;

                      return (
                        <span className={Styles.valuesHead}>
                          {requiredReturn.toFixed(2)} MWh
                        </span>
                      );
                    }
                  })()}
                </div>

                {(() => {
                  if (isInjectionOnTop) {
                    let totalDrawalMwh = 0;

                    drawalModals.forEach((modal) => {
                      modal.forEach((slot) => {
                        const qty = Number(slot.quantity) || 0;
                        const days =
                          slot.startDate && slot.endDate
                            ? (new Date(slot.endDate) -
                                new Date(slot.startDate)) /
                                (1000 * 60 * 60 * 24) +
                              1
                            : 0;
                        const totalHrs =
                          calculateTotalHours(
                            slot.startTime,
                            slot.endTime === "23:59" ? "24:00" : slot.endTime,
                          ) || 0;
                        const finalMwh = qty * days * totalHrs;
                        totalDrawalMwh += finalMwh;
                      });
                    });
                  } else {
                    let totalInjectionMwh = 0;
                    injectionModals.forEach((modal) => {
                      modal.forEach((slot) => {
                        const qty = Number(slot.quantity) || 0;
                        const days =
                          slot.startDate && slot.endDate
                            ? (new Date(slot.endDate) -
                                new Date(slot.startDate)) /
                                (1000 * 60 * 60 * 24) +
                              1
                            : 0;
                        const totalHrs =
                          calculateTotalHours(
                            slot.startTime,
                            slot.endTime === "23:59" ? "24:00" : slot.endTime,
                          ) || 0;
                        const finalMwh = qty * days * totalHrs;
                        totalInjectionMwh += finalMwh;
                      });
                    });
                  }
                  return null;
                })()}

                <div className={Styles.injectionBox}>
                  <span className={Styles.headingInjDra}>
                    Return Remaining
                    <Tooltip
                      title={
                        isInjectionOnTop
                          ? "Required Return - Return as per Requisitions"
                          : "Return as per Requisitions - Required Return"
                      }
                      arrow
                    >
                      <Info
                        style={{
                          fontSize: 16,
                          color: "#666",
                          marginLeft: "4px",
                        }}
                      />
                    </Tooltip>
                  </span>

                  {(() => {
                    const factor = Number(bankingFactor) || 0;

                    let totalInjectionMwh = 0;
                    injectionModals.forEach((modal) => {
                      modal.forEach((slot) => {
                        const qty = Number(slot.quantity) || 0;

                        const days =
                          slot.startDate && slot.endDate
                            ? (new Date(slot.endDate) -
                                new Date(slot.startDate)) /
                                (1000 * 60 * 60 * 24) +
                              1
                            : 0;

                        const totalHrs =
                          calculateTotalHours(
                            slot.startTime,
                            slot.endTime === "23:59" ? "24:00" : slot.endTime,
                          ) || 0;
                        const finalMwh = qty * days * totalHrs;
                        totalInjectionMwh += finalMwh;
                      });
                    });

                    let totalDrawalMwh = 0;
                    drawalModals.forEach((modal) => {
                      modal.forEach((slot) => {
                        const qty = Number(slot.quantity) || 0;
                        const days =
                          slot.startDate && slot.endDate
                            ? (new Date(slot.endDate) -
                                new Date(slot.startDate)) /
                                (1000 * 60 * 60 * 24) +
                              1
                            : 0;
                        const totalHrs =
                          calculateTotalHours(
                            slot.startTime,
                            slot.endTime === "23:59" ? "24:00" : slot.endTime,
                          ) || 0;
                        const finalMwh = qty * days * totalHrs;
                        totalDrawalMwh += finalMwh;
                      });
                    });

                    let returnRemaining = 0;
                    let shouldShow = false;

                    if (isInjectionOnTop) {
                      const requiredReturn = (totalInjectionMwh * factor) / 100;
                      returnRemaining = requiredReturn - totalDrawalMwh;
                      shouldShow = factor > 0 && totalInjectionMwh > 0;
                    } else {
                      const requiredReturn =
                        factor > 0 ? (totalDrawalMwh * factor) / 100 : 0;
                      returnRemaining = requiredReturn - totalInjectionMwh;
                      shouldShow = factor > 0 && totalDrawalMwh > 0;
                    }
                    return (
                      <div style={{ fontSize: "11px", marginTop: "4px" }}>
                        <span className={Styles.valuesHead}>
                          {Number(returnRemaining.toFixed(2)) === 0
                            ? "0.00"
                            : returnRemaining.toFixed(2)}{" "}
                          MWh
                        </span>
                      </div>
                    );
                  })()}
                </div>
              </div>
            </FormGroup>

            <div className={`display_flex_column_gap_4`}>
              <div
                className={`display_flex_row_common ${Styles.eachSelectionMainContainer}`}
              >
                <DateInput
                  heading={
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "4px",
                      }}
                    >
                      Listing Expiry Date *
                      <Tooltip
                        title=" No further action will be allowed after expiry.Listing Expiry must be at least 3 hours before the earliest start time."
                        arrow
                      >
                        <Info style={{ fontSize: 16, color: "#666" }} />
                      </Tooltip>
                    </div>
                  }
                  value={expiryDate}
                  minDate={today}
                  onChange={handleExpiryDateChange}
                  height={35}
                  error={errors.expiryDate}
                  errorMessage={errors.expiryDate}
                />
                <TimeInput
                  heading="Listing Expiry Time"
                  value={expiryTime}
                  onChange={handleExpiryTimeChange}
                  height={35}
                  error={errors.expiryTime}
                  errorMessage={errors.expiryTime}
                />
                <div style={{ width: "150rem" }}>
                  <TextInput
                    heading="Comments"
                    value={comments}
                    example={"Any Comments"}
                    onChange={handleCommentsChange}
                    height={35}
                  />
                </div>
                {/* T&C expiry is kept in state and sent to backend but hidden from UI */}
              </div>
              <div
                style={{ color: "gray", fontSize: "8px", marginTop: "12px" }}
                className={`display_flex_row ${Styles.expiryDateTime}`}
              >
                <div className={Styles.termsPoint}>
                  <span>
                    *Expiry date/time cannot be edited once the listing is
                    created
                  </span>
                  <span>
                    *Listing terms and conditions can be finalized upto 3 hours
                    before the start of the first schedule (subject to
                    applicable regulations).
                  </span>
                </div>
                <div className={Styles.termsPointOther}>
                  {" "}
                  <span>
                    <Checkbox
                      checked={checked}
                      onChange={handleChange}
                      sx={{
                        "&.Mui-checked": {
                          color: "#f1935c",
                        },
                      }}
                      slotProps={{
                        input: { "aria-label": "controlled" },
                      }}
                    />
                  </span>
                  <span className={Styles.termsAction}>
                    T&C Approval
                    <Tooltip
                      title="Upon acceptance of a connection request that is a 100% match to my listing, the listing details shall constitute the Final Terms & Conditions agreed upon by both parties, and the parties may directly proceed with the required documentation. "
                      arrow
                    >
                      <Info
                        style={{
                          fontSize: 16,
                          color: "#666",
                          paddingLeft: "4px",
                          cursor: "pointer",
                        }}
                      />
                    </Tooltip>
                  </span>{" "}
                </div>
              </div>
            </div>

            <div className={Styles.level6Continaer} style={{ marginTop: 8 }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  fontSize: "12px",
                  color: "#8C8A96",
                  fontWeight: 400,
                }}
              >
                <input
                  type="checkbox"
                  style={{ marginRight: "8px" }}
                  checked={acceptSystemTerms}
                  onChange={(e) => {
                    setAcceptSystemTerms(e.target.checked);
                    if (e.target.checked) setTermsError(null);
                  }}
                />
                I Understand and Accept&nbsp;
                <span
                  onClick={() => {
                    handlePreviewGeneralTerms(
                      "https://gna-general-files.s3.ap-south-1.amazonaws.com/Website+Assets+PDF/GNA-bye-laws.pdf",
                      {
                        hideHeader: true,
                      },
                    );
                  }}
                  type="button"
                  style={{
                    color: "#ff9800",
                    cursor: "pointer",
                  }}
                >
                  System Terms and Conditions
                </span>
              </div>

              {termsError && (
                <div
                  style={{ color: "red", fontSize: "12px", marginTop: "8px" }}
                >
                  {termsError}
                </div>
              )}
            </div>

            {/* <div className={`display_flex_column_gap_4`}>
              <div
                className={`display_flex_row_common ${Styles.eachSelectionMainContainer}`}
              >
                <TextInput
                  heading="Comments"
                  value={comments}
                  onChange={handleCommentsChange}
                />
              </div>
            </div> */}
          </div>

          <div
            className={`display_flex_row_center ${Styles.buttonMainContainer}`}
          >
            <div
              className={Styles.cancelBankButton}
              onClick={handleClose}
              style={{ cursor: "pointer" }}
            >
              Cancel
            </div>
            <div
              className={`activeButton ${Styles.activeButton_modal}`}
              // onClick={!isLoading ? handleSubmitClick : null}
              onClick={() => {
                setConfirmToggleOpen(true);
                setSubmitConfirmModalOpen(true);
              }}
              style={{
                pointerEvents: isLoading ? "none" : "auto",
                opacity: isLoading ? 0.6 : 1,
              }}
            >
              {isLoading ? "Submitting..." : "Submit"}
            </div>
          </div>
        </div>
      </Modal>
      <PreviewModal
        open={previewModal}
        onClose={handleClosePreview}
        fileUrl={previewFileUrl}
        fileName={previewFileName}
        disableDownload={true}
      />
    </>
  );
};

export default ConnectListingModal;
